var Ze = function(e, t) {
  return Ze = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
  }, Ze(e, t);
};
function N(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  Ze(e, t);
  function r() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
}
var d = function() {
  return d = Object.assign || function(t) {
    for (var r, n = 1, i = arguments.length; n < i; n++) {
      r = arguments[n];
      for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (t[o] = r[o]);
    }
    return t;
  }, d.apply(this, arguments);
};
function Ht(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(e); i < n.length; i++)
      t.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[i]) && (r[n[i]] = e[n[i]]);
  return r;
}
function g(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        c(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      try {
        c(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      l.done ? o(l.value) : i(l.value).then(u, s);
    }
    c((n = n.apply(e, t || [])).next());
  });
}
function m(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(c) {
    return function(l) {
      return s([c, l]);
    };
  }
  function s(c) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; a && (a = 0, c[0] && (r = 0)), r; ) try {
      if (n = 1, i && (o = c[0] & 2 ? i.return : c[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, c[1])).done) return o;
      switch (i = 0, o && (c = [c[0] & 2, o.value]), c[0]) {
        case 0:
        case 1:
          o = c;
          break;
        case 4:
          return r.label++, { value: c[1], done: !1 };
        case 5:
          r.label++, i = c[1], c = [0];
          continue;
        case 7:
          c = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (c[0] === 6 || c[0] === 2)) {
            r = 0;
            continue;
          }
          if (c[0] === 3 && (!o || c[1] > o[0] && c[1] < o[3])) {
            r.label = c[1];
            break;
          }
          if (c[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = c;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(c);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      c = t.call(e, r);
    } catch (l) {
      c = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (c[0] & 5) throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}
function D(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}
function et(e, t, r) {
  t.split && (t = t.split("."));
  for (var n = 0, i = t.length, o = e, a, u; n < i && (u = "" + t[n++], !(u === "__proto__" || u === "constructor" || u === "prototype")); )
    o = o[u] = n === i ? r : typeof (a = o[u]) == typeof t ? a : t[n] * 0 !== 0 || ~("" + t[n]).indexOf(".") ? {} : [];
}
var Fr = function(e, t) {
  return Object.keys(e).filter(function(r) {
    return t(r, e[r]);
  }).reduce(function(r, n) {
    return r[n] = e[n], r;
  }, {});
}, ie = (
  /** @class */
  function(e) {
    N(t, e);
    function t(r, n) {
      var i = e.call(this, "".concat(r, " ").concat(n)) || this;
      return i.field = r, i;
    }
    return t;
  }(Error)
);
function ae(e) {
  return typeof e == "string";
}
function tt(e) {
  return typeof e == "number";
}
function pe(e) {
  return typeof e == "function";
}
function jr(e) {
  return e != null;
}
function q(e) {
  return Object.prototype.toString.call(e).slice(8, -1).toLowerCase() === "object";
}
var lt = "is not a string", ft = "is not an object", Tr = "is nil";
function Nr(e) {
  if (!jr(e))
    throw new ie("Event", Tr);
  if (typeof e != "object")
    throw new ie("Event", ft);
}
function Lr(e) {
  if (!ae(e.type))
    throw new ie(".type", lt);
}
function Rr(e) {
  if (!ae(e.event))
    throw new ie(".event", lt);
}
function qr(e) {
  if (!q(e.properties))
    throw new ie(".properties", ft);
}
function $r(e) {
  if (!q(e.traits))
    throw new ie(".traits", ft);
}
function Ur(e) {
  if (!ae(e.messageId))
    throw new ie(".messageId", lt);
}
function zr(e) {
  Nr(e), Lr(e), Ur(e), e.type === "track" && (Rr(e), qr(e)), ["group", "identify"].includes(e.type) && $r(e);
}
var Br = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      var r, n;
      this.settings = t, this.createMessageId = t.createMessageId, this.onEventMethodCall = (r = t.onEventMethodCall) !== null && r !== void 0 ? r : function() {
      }, this.onFinishedEvent = (n = t.onFinishedEvent) !== null && n !== void 0 ? n : function() {
      };
    }
    return e;
  }()
), Kr = (
  /** @class */
  function() {
    function e(t) {
      this.settings = new Br(t);
    }
    return e.prototype.track = function(t, r, n, i) {
      return this.settings.onEventMethodCall({ type: "track", options: n }), this.normalize(d(d({}, this.baseEvent()), { event: t, type: "track", properties: r ?? {}, options: d({}, n), integrations: d({}, i) }));
    }, e.prototype.page = function(t, r, n, i, o) {
      var a;
      this.settings.onEventMethodCall({ type: "page", options: i });
      var u = {
        type: "page",
        properties: d({}, n),
        options: d({}, i),
        integrations: d({}, o)
      };
      return t !== null && (u.category = t, u.properties = (a = u.properties) !== null && a !== void 0 ? a : {}, u.properties.category = t), r !== null && (u.name = r), this.normalize(d(d({}, this.baseEvent()), u));
    }, e.prototype.screen = function(t, r, n, i, o) {
      this.settings.onEventMethodCall({ type: "screen", options: i });
      var a = {
        type: "screen",
        properties: d({}, n),
        options: d({}, i),
        integrations: d({}, o)
      };
      return t !== null && (a.category = t), r !== null && (a.name = r), this.normalize(d(d({}, this.baseEvent()), a));
    }, e.prototype.identify = function(t, r, n, i) {
      return this.settings.onEventMethodCall({ type: "identify", options: n }), this.normalize(d(d({}, this.baseEvent()), { type: "identify", userId: t, traits: r ?? {}, options: d({}, n), integrations: i }));
    }, e.prototype.group = function(t, r, n, i) {
      return this.settings.onEventMethodCall({ type: "group", options: n }), this.normalize(d(d({}, this.baseEvent()), {
        type: "group",
        traits: r ?? {},
        options: d({}, n),
        integrations: d({}, i),
        //
        groupId: t
      }));
    }, e.prototype.alias = function(t, r, n, i) {
      this.settings.onEventMethodCall({ type: "alias", options: n });
      var o = {
        userId: t,
        type: "alias",
        options: d({}, n),
        integrations: d({}, i)
      };
      return r !== null && (o.previousId = r), t === void 0 ? this.normalize(d(d({}, o), this.baseEvent())) : this.normalize(d(d({}, this.baseEvent()), o));
    }, e.prototype.baseEvent = function() {
      return {
        integrations: {},
        options: {}
      };
    }, e.prototype.context = function(t) {
      var r, n = [
        "userId",
        "anonymousId",
        "timestamp",
        "messageId"
      ];
      delete t.integrations;
      var i = Object.keys(t), o = (r = t.context) !== null && r !== void 0 ? r : {}, a = {};
      return i.forEach(function(u) {
        u !== "context" && (n.includes(u) ? et(a, u, t[u]) : et(o, u, t[u]));
      }), [o, a];
    }, e.prototype.normalize = function(t) {
      var r, n, i = Object.keys((r = t.integrations) !== null && r !== void 0 ? r : {}).reduce(function(h, v) {
        var p, y;
        return d(d({}, h), (p = {}, p[v] = !!(!((y = t.integrations) === null || y === void 0) && y[v]), p));
      }, {});
      t.options = Fr(t.options || {}, function(h, v) {
        return v !== void 0;
      });
      var o = d(d({}, i), (n = t.options) === null || n === void 0 ? void 0 : n.integrations), a = t.options ? this.context(t.options) : [], u = a[0], s = a[1], c = t.options, l = Ht(t, ["options"]), f = d(d(d(d({ timestamp: /* @__PURE__ */ new Date() }, l), { context: u, integrations: o }), s), { messageId: c.messageId || this.settings.createMessageId() });
      return this.settings.onFinishedEvent(f), zr(f), f;
    }, e;
  }()
);
function Gr(e, t) {
  return new Promise(function(r, n) {
    var i = setTimeout(function() {
      n(Error("Promise timed out"));
    }, t);
    e.then(function(o) {
      return clearTimeout(i), r(o);
    }).catch(n);
  });
}
function Jr(e) {
  return new Promise(function(t) {
    return setTimeout(t, e);
  });
}
function Wr(e, t, r) {
  var n = function() {
    try {
      return Promise.resolve(t(e));
    } catch (i) {
      return Promise.reject(i);
    }
  };
  return Jr(r).then(function() {
    return Gr(n(), 1e3);
  }).catch(function(i) {
    e == null || e.log("warn", "Callback Error", { error: i }), e == null || e.stats.increment("callback_error");
  }).then(function() {
    return e;
  });
}
var Yt = function() {
  var e, t, r = !1, n = new Promise(function(i, o) {
    e = function() {
      for (var a = [], u = 0; u < arguments.length; u++)
        a[u] = arguments[u];
      r = !0, i.apply(void 0, a);
    }, t = function() {
      for (var a = [], u = 0; u < arguments.length; u++)
        a[u] = arguments[u];
      r = !0, o.apply(void 0, a);
    };
  });
  return {
    resolve: e,
    reject: t,
    promise: n,
    isSettled: function() {
      return r;
    }
  };
}, dt = (
  /** @class */
  function() {
    function e(t) {
      var r;
      this.callbacks = {}, this.warned = !1, this.maxListeners = (r = t == null ? void 0 : t.maxListeners) !== null && r !== void 0 ? r : 10;
    }
    return e.prototype.warnIfPossibleMemoryLeak = function(t) {
      this.warned || this.maxListeners && this.callbacks[t].length > this.maxListeners && (console.warn("Event Emitter: Possible memory leak detected; ".concat(String(t), " has exceeded ").concat(this.maxListeners, " listeners.")), this.warned = !0);
    }, e.prototype.on = function(t, r) {
      return this.callbacks[t] ? (this.callbacks[t].push(r), this.warnIfPossibleMemoryLeak(t)) : this.callbacks[t] = [r], this;
    }, e.prototype.once = function(t, r) {
      var n = this, i = function() {
        for (var o = [], a = 0; a < arguments.length; a++)
          o[a] = arguments[a];
        n.off(t, i), r.apply(n, o);
      };
      return this.on(t, i), this;
    }, e.prototype.off = function(t, r) {
      var n, i = (n = this.callbacks[t]) !== null && n !== void 0 ? n : [], o = i.filter(function(a) {
        return a !== r;
      });
      return this.callbacks[t] = o, this;
    }, e.prototype.emit = function(t) {
      for (var r = this, n, i = [], o = 1; o < arguments.length; o++)
        i[o - 1] = arguments[o];
      var a = (n = this.callbacks[t]) !== null && n !== void 0 ? n : [];
      return a.forEach(function(u) {
        u.apply(r, i);
      }), this;
    }, e;
  }()
);
function Qr(e) {
  var t = Math.random() + 1, r = e.minTimeout, n = r === void 0 ? 500 : r, i = e.factor, o = i === void 0 ? 2 : i, a = e.attempt, u = e.maxTimeout, s = u === void 0 ? 1 / 0 : u;
  return Math.min(t * n * Math.pow(o, a), s);
}
var Xt = "onRemoveFromFuture", pt = (
  /** @class */
  function(e) {
    N(t, e);
    function t(r, n, i) {
      var o = e.call(this) || this;
      return o.future = [], o.maxAttempts = r, o.queue = n, o.seen = i ?? {}, o;
    }
    return t.prototype.push = function() {
      for (var r = this, n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      var o = n.map(function(a) {
        var u = r.updateAttempts(a);
        return u > r.maxAttempts || r.includes(a) ? !1 : (r.queue.push(a), !0);
      });
      return this.queue = this.queue.sort(function(a, u) {
        return r.getAttempts(a) - r.getAttempts(u);
      }), o;
    }, t.prototype.pushWithBackoff = function(r, n) {
      var i = this;
      if (n === void 0 && (n = 0), n == 0 && this.getAttempts(r) === 0)
        return this.push(r)[0];
      var o = this.updateAttempts(r);
      if (o > this.maxAttempts || this.includes(r))
        return !1;
      var a = Qr({ attempt: o - 1 });
      return n > 0 && a < n && (a = n), setTimeout(function() {
        i.queue.push(r), i.future = i.future.filter(function(u) {
          return u.id !== r.id;
        }), i.emit(Xt);
      }, a), this.future.push(r), !0;
    }, t.prototype.getAttempts = function(r) {
      var n;
      return (n = this.seen[r.id]) !== null && n !== void 0 ? n : 0;
    }, t.prototype.updateAttempts = function(r) {
      return this.seen[r.id] = this.getAttempts(r) + 1, this.getAttempts(r);
    }, t.prototype.includes = function(r) {
      return this.queue.includes(r) || this.future.includes(r) || !!this.queue.find(function(n) {
        return n.id === r.id;
      }) || !!this.future.find(function(n) {
        return n.id === r.id;
      });
    }, t.prototype.pop = function() {
      return this.queue.shift();
    }, Object.defineProperty(t.prototype, "length", {
      get: function() {
        return this.queue.length;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "todo", {
      get: function() {
        return this.queue.length + this.future.length;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(dt)
), te = 256, ke = [], Ae;
for (; te--; ) ke[te] = (te + 256).toString(16).substring(1);
function vt() {
  var e = 0, t, r = "";
  if (!Ae || te + 16 > 256) {
    for (Ae = Array(e = 256); e--; ) Ae[e] = 256 * Math.random() | 0;
    e = te = 0;
  }
  for (; e < 16; e++)
    t = Ae[te + e], e == 6 ? r += ke[t & 15 | 64] : e == 8 ? r += ke[t & 63 | 128] : r += ke[t], e & 1 && e > 1 && e < 11 && (r += "-");
  return te++, r;
}
var Vr = (
  /** @class */
  function() {
    function e() {
      this._logs = [];
    }
    return e.prototype.log = function(t, r, n) {
      var i = /* @__PURE__ */ new Date();
      this._logs.push({
        level: t,
        message: r,
        time: i,
        extras: n
      });
    }, Object.defineProperty(e.prototype, "logs", {
      get: function() {
        return this._logs;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.flush = function() {
      if (this.logs.length > 1) {
        var t = this._logs.reduce(function(r, n) {
          var i, o, a, u = d(d({}, n), { json: JSON.stringify(n.extras, null, " "), extras: n.extras });
          delete u.time;
          var s = (a = (o = n.time) === null || o === void 0 ? void 0 : o.toISOString()) !== null && a !== void 0 ? a : "";
          return r[s] && (s = "".concat(s, "-").concat(Math.random())), d(d({}, r), (i = {}, i[s] = u, i));
        }, {});
        console.table ? console.table(t) : console.log(t);
      } else
        this.logs.forEach(function(r) {
          var n = r.level, i = r.message, o = r.extras;
          n === "info" || n === "debug" ? console.log(i, o ?? "") : console[n](i, o ?? "");
        });
      this._logs = [];
    }, e;
  }()
), Hr = function(e) {
  var t = {
    gauge: "g",
    counter: "c"
  };
  return t[e];
}, Zt = (
  /** @class */
  function() {
    function e() {
      this.metrics = [];
    }
    return e.prototype.increment = function(t, r, n) {
      r === void 0 && (r = 1), this.metrics.push({
        metric: t,
        value: r,
        tags: n ?? [],
        type: "counter",
        timestamp: Date.now()
      });
    }, e.prototype.gauge = function(t, r, n) {
      this.metrics.push({
        metric: t,
        value: r,
        tags: n ?? [],
        type: "gauge",
        timestamp: Date.now()
      });
    }, e.prototype.flush = function() {
      var t = this.metrics.map(function(r) {
        return d(d({}, r), { tags: r.tags.join(",") });
      });
      console.table ? console.table(t) : console.log(t), this.metrics = [];
    }, e.prototype.serialize = function() {
      return this.metrics.map(function(t) {
        return {
          m: t.metric,
          v: t.value,
          t: t.tags,
          k: Hr(t.type),
          e: t.timestamp
        };
      });
    }, e;
  }()
), Yr = (
  /** @class */
  function(e) {
    N(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.gauge = function() {
    }, t.prototype.increment = function() {
    }, t.prototype.flush = function() {
    }, t.prototype.serialize = function() {
      return [];
    }, t;
  }(Zt)
), he = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      var r, n, i;
      this.retry = (r = t.retry) !== null && r !== void 0 ? r : !0, this.type = (n = t.type) !== null && n !== void 0 ? n : "plugin Error", this.reason = (i = t.reason) !== null && i !== void 0 ? i : "";
    }
    return e;
  }()
), Fe = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      r === void 0 && (r = vt()), n === void 0 && (n = new Yr()), i === void 0 && (i = new Vr()), this.attempts = 0, this.event = t, this._id = r, this.logger = i, this.stats = n;
    }
    return e.system = function() {
    }, e.prototype.isSame = function(t) {
      return t.id === this.id;
    }, e.prototype.cancel = function(t) {
      throw t || new he({ reason: "Context Cancel" });
    }, e.prototype.log = function(t, r, n) {
      this.logger.log(t, r, n);
    }, Object.defineProperty(e.prototype, "id", {
      get: function() {
        return this._id;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.updateEvent = function(t, r) {
      var n;
      if (t.split(".")[0] === "integrations") {
        var i = t.split(".")[1];
        if (((n = this.event.integrations) === null || n === void 0 ? void 0 : n[i]) === !1)
          return this.event;
      }
      return et(this.event, t, r), this.event;
    }, e.prototype.failedDelivery = function() {
      return this._failedDelivery;
    }, e.prototype.setFailedDelivery = function(t) {
      this._failedDelivery = t;
    }, e.prototype.logs = function() {
      return this.logger.logs;
    }, e.prototype.flush = function() {
      this.logger.flush(), this.stats.flush();
    }, e.prototype.toJSON = function() {
      return {
        id: this._id,
        event: this.event,
        logs: this.logger.logs,
        metrics: this.stats.metrics
      };
    }, e;
  }()
);
function Xr(e, t) {
  var r = {};
  return e.forEach(function(n) {
    var i, o = void 0;
    {
      var a = n[t];
      o = typeof a != "string" ? JSON.stringify(a) : a;
    }
    o !== void 0 && (r[o] = D(D([], (i = r[o]) !== null && i !== void 0 ? i : [], !0), [n], !1));
  }), r;
}
var Zr = function(e) {
  return typeof e == "object" && e !== null && "then" in e && typeof e.then == "function";
}, en = function() {
  var e, t, r = 0;
  return {
    done: function() {
      return e;
    },
    run: function(n) {
      var i = n();
      return Zr(i) && (++r === 1 && (e = new Promise(function(o) {
        return t = o;
      })), i.finally(function() {
        return --r === 0 && t();
      })), i;
    }
  };
};
function tn(e) {
  return g(this, void 0, void 0, function() {
    var t;
    return m(this, function(r) {
      switch (r.label) {
        case 0:
          return r.trys.push([0, 2, , 3]), [4, e()];
        case 1:
          return [2, r.sent()];
        case 2:
          return t = r.sent(), [2, Promise.reject(t)];
        case 3:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}
function _e(e, t) {
  e.log("debug", "plugin", { plugin: t.name });
  var r = (/* @__PURE__ */ new Date()).getTime(), n = t[e.event.type];
  if (n === void 0)
    return Promise.resolve(e);
  var i = tn(function() {
    return n.apply(t, [e]);
  }).then(function(o) {
    var a = (/* @__PURE__ */ new Date()).getTime() - r;
    return o.stats.gauge("plugin_time", a, ["plugin:".concat(t.name)]), o;
  }).catch(function(o) {
    if (o instanceof he && o.type === "middleware_cancellation")
      throw o;
    return o instanceof he ? (e.log("warn", o.type, {
      plugin: t.name,
      error: o
    }), o) : (e.log("error", "plugin Error", {
      plugin: t.name,
      error: o
    }), e.stats.increment("plugin_error", 1, ["plugin:".concat(t.name)]), o);
  });
  return i;
}
function rn(e, t) {
  return _e(e, t).then(function(r) {
    if (r instanceof Fe)
      return r;
    e.log("debug", "Context canceled"), e.stats.increment("context_canceled"), e.cancel(r);
  });
}
var nn = (
  /** @class */
  function(e) {
    N(t, e);
    function t(r) {
      var n = e.call(this) || this;
      return n.criticalTasks = en(), n.plugins = [], n.failedInitializations = [], n.flushing = !1, n.queue = r, n.queue.on(Xt, function() {
        n.scheduleFlush(0);
      }), n;
    }
    return t.prototype.register = function(r, n, i) {
      return g(this, void 0, void 0, function() {
        var o, a, u = this;
        return m(this, function(s) {
          switch (s.label) {
            case 0:
              return this.plugins.push(n), o = function(c) {
                u.failedInitializations.push(n.name), u.emit("initialization_failure", n), console.warn(n.name, c), r.log("warn", "Failed to load destination", {
                  plugin: n.name,
                  error: c
                }), u.plugins = u.plugins.filter(function(l) {
                  return l !== n;
                });
              }, n.type === "destination" && n.name !== "Segment.io" ? (n.load(r, i).catch(o), [3, 4]) : [3, 1];
            case 1:
              return s.trys.push([1, 3, , 4]), [4, n.load(r, i)];
            case 2:
              return s.sent(), [3, 4];
            case 3:
              return a = s.sent(), o(a), [3, 4];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.deregister = function(r, n, i) {
      return g(this, void 0, void 0, function() {
        var o;
        return m(this, function(a) {
          switch (a.label) {
            case 0:
              return a.trys.push([0, 3, , 4]), n.unload ? [4, Promise.resolve(n.unload(r, i))] : [3, 2];
            case 1:
              a.sent(), a.label = 2;
            case 2:
              return this.plugins = this.plugins.filter(function(u) {
                return u.name !== n.name;
              }), [3, 4];
            case 3:
              return o = a.sent(), r.log("warn", "Failed to unload destination", {
                plugin: n.name,
                error: o
              }), [3, 4];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.dispatch = function(r) {
      return g(this, void 0, void 0, function() {
        var n;
        return m(this, function(i) {
          return r.log("debug", "Dispatching"), r.stats.increment("message_dispatched"), this.queue.push(r), n = this.subscribeToDelivery(r), this.scheduleFlush(0), [2, n];
        });
      });
    }, t.prototype.subscribeToDelivery = function(r) {
      return g(this, void 0, void 0, function() {
        var n = this;
        return m(this, function(i) {
          return [2, new Promise(function(o) {
            var a = function(u, s) {
              u.isSame(r) && (n.off("flush", a), o(u));
            };
            n.on("flush", a);
          })];
        });
      });
    }, t.prototype.dispatchSingle = function(r) {
      return g(this, void 0, void 0, function() {
        var n = this;
        return m(this, function(i) {
          return r.log("debug", "Dispatching"), r.stats.increment("message_dispatched"), this.queue.updateAttempts(r), r.attempts = 1, [2, this.deliver(r).catch(function(o) {
            var a = n.enqueuRetry(o, r);
            return a ? n.subscribeToDelivery(r) : (r.setFailedDelivery({ reason: o }), r);
          })];
        });
      });
    }, t.prototype.isEmpty = function() {
      return this.queue.length === 0;
    }, t.prototype.scheduleFlush = function(r) {
      var n = this;
      r === void 0 && (r = 500), !this.flushing && (this.flushing = !0, setTimeout(function() {
        n.flush().then(function() {
          setTimeout(function() {
            n.flushing = !1, n.queue.length && n.scheduleFlush(0);
          }, 0);
        });
      }, r));
    }, t.prototype.deliver = function(r) {
      return g(this, void 0, void 0, function() {
        var n, i, o, a;
        return m(this, function(u) {
          switch (u.label) {
            case 0:
              return [4, this.criticalTasks.done()];
            case 1:
              u.sent(), n = Date.now(), u.label = 2;
            case 2:
              return u.trys.push([2, 4, , 5]), [4, this.flushOne(r)];
            case 3:
              return r = u.sent(), i = Date.now() - n, this.emit("delivery_success", r), r.stats.gauge("delivered", i), r.log("debug", "Delivered", r.event), [2, r];
            case 4:
              throw o = u.sent(), a = o, r.log("error", "Failed to deliver", a), this.emit("delivery_failure", r, a), r.stats.increment("delivery_failed"), o;
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.enqueuRetry = function(r, n) {
      var i = !(r instanceof he) || r.retry;
      return i ? this.queue.pushWithBackoff(n) : !1;
    }, t.prototype.flush = function() {
      return g(this, void 0, void 0, function() {
        var r, n, i;
        return m(this, function(o) {
          switch (o.label) {
            case 0:
              if (this.queue.length === 0)
                return [2, []];
              if (r = this.queue.pop(), !r)
                return [2, []];
              r.attempts = this.queue.getAttempts(r), o.label = 1;
            case 1:
              return o.trys.push([1, 3, , 4]), [4, this.deliver(r)];
            case 2:
              return r = o.sent(), this.emit("flush", r, !0), [3, 4];
            case 3:
              return n = o.sent(), i = this.enqueuRetry(n, r), i || (r.setFailedDelivery({ reason: n }), this.emit("flush", r, !1)), [2, []];
            case 4:
              return [2, [r]];
          }
        });
      });
    }, t.prototype.isReady = function() {
      return !0;
    }, t.prototype.availableExtensions = function(r) {
      var n = this.plugins.filter(function(v) {
        var p, y, S;
        if (v.type !== "destination" && v.name !== "Segment.io")
          return !0;
        var w = void 0;
        return (p = v.alternativeNames) === null || p === void 0 || p.forEach(function(I) {
          r[I] !== void 0 && (w = r[I]);
        }), (S = (y = r[v.name]) !== null && y !== void 0 ? y : w) !== null && S !== void 0 ? S : (v.name === "Segment.io" ? !0 : r.All) !== !1;
      }), i = Xr(n, "type"), o = i.before, a = o === void 0 ? [] : o, u = i.enrichment, s = u === void 0 ? [] : u, c = i.destination, l = c === void 0 ? [] : c, f = i.after, h = f === void 0 ? [] : f;
      return {
        before: a,
        enrichment: s,
        destinations: l,
        after: h
      };
    }, t.prototype.flushOne = function(r) {
      var n, i;
      return g(this, void 0, void 0, function() {
        var o, a, u, s, c, l, p, f, h, v, p, y, S, w, I;
        return m(this, function(b) {
          switch (b.label) {
            case 0:
              if (!this.isReady())
                throw new Error("Not ready");
              r.attempts > 1 && this.emit("delivery_retry", r), o = this.availableExtensions((n = r.event.integrations) !== null && n !== void 0 ? n : {}), a = o.before, u = o.enrichment, s = 0, c = a, b.label = 1;
            case 1:
              return s < c.length ? (l = c[s], [4, rn(r, l)]) : [3, 4];
            case 2:
              p = b.sent(), p instanceof Fe && (r = p), this.emit("message_enriched", r, l), b.label = 3;
            case 3:
              return s++, [3, 1];
            case 4:
              f = 0, h = u, b.label = 5;
            case 5:
              return f < h.length ? (v = h[f], [4, _e(r, v)]) : [3, 8];
            case 6:
              p = b.sent(), p instanceof Fe && (r = p), this.emit("message_enriched", r, v), b.label = 7;
            case 7:
              return f++, [3, 5];
            case 8:
              return y = this.availableExtensions((i = r.event.integrations) !== null && i !== void 0 ? i : {}), S = y.destinations, w = y.after, [4, new Promise(function(M, O) {
                setTimeout(function() {
                  var x = S.map(function(R) {
                    return _e(r, R);
                  });
                  Promise.all(x).then(M).catch(O);
                }, 0);
              })];
            case 9:
              return b.sent(), r.stats.increment("message_delivered"), this.emit("message_delivered", r), I = w.map(function(M) {
                return _e(r, M);
              }), [4, Promise.all(I)];
            case 10:
              return b.sent(), [2, r];
          }
        });
      });
    }, t;
  }(dt)
), on = function(e, t) {
  var r = Date.now() - e;
  return Math.max((t ?? 300) - r, 0);
};
function an(e, t, r, n) {
  return g(this, void 0, void 0, function() {
    var i, o;
    return m(this, function(a) {
      switch (a.label) {
        case 0:
          return r.emit("dispatch_start", e), i = Date.now(), t.isEmpty() ? [4, t.dispatchSingle(e)] : [3, 2];
        case 1:
          return o = a.sent(), [3, 4];
        case 2:
          return [4, t.dispatch(e)];
        case 3:
          o = a.sent(), a.label = 4;
        case 4:
          return n != null && n.callback ? [4, Wr(o, n.callback, on(i, n.timeout))] : [3, 6];
        case 5:
          o = a.sent(), a.label = 6;
        case 6:
          return n != null && n.debug && o.flush(), [2, o];
      }
    });
  });
}
function un(e, t, r, n) {
  var i, o = [e, t, r, n], a = q(e) ? e.event : e;
  if (!a || !ae(a))
    throw new Error("Event missing");
  var u = q(e) ? (i = e.properties) !== null && i !== void 0 ? i : {} : q(t) ? t : {}, s = {};
  pe(r) || (s = r ?? {}), q(e) && !pe(t) && (s = t ?? {});
  var c = o.find(pe);
  return [a, u, s, c];
}
function qt(e, t, r, n, i) {
  var o, a, u = null, s = null, c = [e, t, r, n, i], l = c.filter(ae);
  l[0] !== void 0 && l[1] !== void 0 && (u = l[0], s = l[1]), l.length === 1 && (u = null, s = l[0]);
  var f = c.find(pe), h = c.filter(function(y) {
    return s === null ? q(y) : q(y) || y === null;
  }), v = (o = h[0]) !== null && o !== void 0 ? o : {}, p = (a = h[1]) !== null && a !== void 0 ? a : {};
  return [
    u,
    s,
    v,
    p,
    f
  ];
}
var $t = function(e) {
  return function() {
    for (var t, r, n, i = [], o = 0; o < arguments.length; o++)
      i[o] = arguments[o];
    for (var a = {}, u = [
      "callback",
      "options",
      "traits",
      "id"
    ], s = 0, c = i; s < c.length; s++) {
      var l = c[s], f = u.pop();
      if (f === "id") {
        if (ae(l) || tt(l)) {
          a.id = l.toString();
          continue;
        }
        if (l == null)
          continue;
        f = u.pop();
      }
      if ((f === "traits" || f === "options") && (l == null || q(l)) && (a[f] = l), pe(l)) {
        a.callback = l;
        break;
      }
    }
    return [
      (t = a.id) !== null && t !== void 0 ? t : e.id(),
      (r = a.traits) !== null && r !== void 0 ? r : {},
      (n = a.options) !== null && n !== void 0 ? n : {},
      a.callback
    ];
  };
};
function sn(e, t, r, n) {
  tt(e) && (e = e.toString()), tt(t) && (t = t.toString());
  var i = [e, t, r, n], o = i.filter(ae), a = o[0], u = a === void 0 ? e : a, s = o[1], c = s === void 0 ? null : s, l = i.filter(q)[0], f = l === void 0 ? {} : l, h = i.find(pe);
  return [u, c, f, h];
}
function ht() {
  return typeof window < "u";
}
function Fo() {
  return !ht();
}
function cn() {
  return ht() ? window.navigator.onLine : !0;
}
function Se() {
  return !cn();
}
function ln(e, t) {
  return t = t || {}, new Promise(function(r, n) {
    var i = new XMLHttpRequest(), o = [], a = [], u = {}, s = function() {
      return { ok: (i.status / 100 | 0) == 2, statusText: i.statusText, status: i.status, url: i.responseURL, text: function() {
        return Promise.resolve(i.responseText);
      }, json: function() {
        return Promise.resolve(i.responseText).then(JSON.parse);
      }, blob: function() {
        return Promise.resolve(new Blob([i.response]));
      }, clone: s, headers: { keys: function() {
        return o;
      }, entries: function() {
        return a;
      }, get: function(l) {
        return u[l.toLowerCase()];
      }, has: function(l) {
        return l.toLowerCase() in u;
      } } };
    };
    for (var c in i.open(t.method || "get", e, !0), i.onload = function() {
      i.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(l, f, h) {
        o.push(f = f.toLowerCase()), a.push([f, h]), u[f] = u[f] ? u[f] + "," + h : h;
      }), r(s());
    }, i.onerror = n, i.withCredentials = t.credentials == "include", t.headers) i.setRequestHeader(c, t.headers[c]);
    i.send(t.body || null);
  });
}
var yt = function() {
  return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : null;
}, Ne = function() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var r = yt();
  return (r && r.fetch || ln).apply(void 0, e);
}, Le = "1.76.0", er = "api.segment.io/v1", fn = function(e, t, r) {
  var n = t.reduce(function(i, o) {
    var a = o.split(":"), u = a[0], s = a[1];
    return i[u] = s, i;
  }, {});
  return {
    type: "Counter",
    metric: e,
    value: 1,
    tags: d(d({}, n), { library: "analytics.js", library_version: "npm:next-".concat(Le) })
  };
};
function We(e) {
  console.error("Error sending segment performance metrics", e);
}
var dn = (
  /** @class */
  function() {
    function e(t) {
      var r = this, n, i, o, a, u;
      if (this.host = (n = t == null ? void 0 : t.host) !== null && n !== void 0 ? n : er, this.sampleRate = (i = t == null ? void 0 : t.sampleRate) !== null && i !== void 0 ? i : 1, this.flushTimer = (o = t == null ? void 0 : t.flushTimer) !== null && o !== void 0 ? o : 30 * 1e3, this.maxQueueSize = (a = t == null ? void 0 : t.maxQueueSize) !== null && a !== void 0 ? a : 20, this.protocol = (u = t == null ? void 0 : t.protocol) !== null && u !== void 0 ? u : "https", this.queue = [], this.sampleRate > 0) {
        var s = !1, c = function() {
          s || (s = !0, r.flush().catch(We), s = !1, setTimeout(c, r.flushTimer));
        };
        c();
      }
    }
    return e.prototype.increment = function(t, r) {
      if (t.includes("analytics_js.") && r.length !== 0 && !(Math.random() > this.sampleRate) && !(this.queue.length >= this.maxQueueSize)) {
        var n = fn(t, r);
        this.queue.push(n), t.includes("error") && this.flush().catch(We);
      }
    }, e.prototype.flush = function() {
      return g(this, void 0, void 0, function() {
        var t = this;
        return m(this, function(r) {
          switch (r.label) {
            case 0:
              return this.queue.length <= 0 ? [
                2
                /*return*/
              ] : [4, this.send().catch(function(n) {
                We(n), t.sampleRate = 0;
              })];
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.send = function() {
      return g(this, void 0, void 0, function() {
        var t, r, n;
        return m(this, function(i) {
          return t = { series: this.queue }, this.queue = [], r = { "Content-Type": "text/plain" }, n = "".concat(this.protocol, "://").concat(this.host, "/m"), [2, Ne(n, {
            headers: r,
            body: JSON.stringify(t),
            method: "POST"
          })];
        });
      });
    }, e;
  }()
), xe, tr = (
  /** @class */
  function(e) {
    N(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.initRemoteMetrics = function(r) {
      xe = new dn(r);
    }, t.prototype.increment = function(r, n, i) {
      e.prototype.increment.call(this, r, n, i), xe == null || xe.increment(r, i ?? []);
    }, t;
  }(Zt)
), Q = (
  /** @class */
  function(e) {
    N(t, e);
    function t(r, n) {
      return e.call(this, r, n, new tr()) || this;
    }
    return t.system = function() {
      return new this({ type: "track", event: "system" });
    }, t;
  }(Fe)
), rr = "bpc", nr = function(e, t, r, n, i, o) {
  return {
    __t: rr,
    c: t,
    p: n,
    u: e,
    s: r,
    t: i,
    r: o
  };
}, pn = Object.keys(nr("", "", "", "", "", ""));
function vn(e) {
  if (!q(e) || e.__t !== rr)
    return !1;
  for (var t in e)
    if (!pn.includes(t))
      return !1;
  return !0;
}
var hn = function(e, t) {
  return e.indexOf("?") > -1 ? e : e + t;
}, yn = function(e) {
  var t = e.indexOf("#");
  return t === -1 ? e : e.slice(0, t);
}, gn = function(e) {
  try {
    return new URL(e).pathname;
  } catch {
    return e[0] === "/" ? e : "/" + e;
  }
}, ir = function(e) {
  var t = e.c, r = e.p, n = e.s, i = e.u, o = e.r, a = e.t, u = t ? gn(t) : r, s = t ? hn(t, n) : yn(i);
  return {
    path: u,
    referrer: o,
    search: n,
    title: a,
    url: s
  };
}, or = function() {
  var e = document.querySelector("link[rel='canonical']");
  return nr(location.href, e && e.getAttribute("href") || void 0, location.search, location.pathname, document.title, document.referrer);
}, mn = function() {
  return ir(or());
};
function bn(e, t) {
  return Object.assign.apply(Object, D([{}], t.map(function(r) {
    var n;
    if (e && Object.prototype.hasOwnProperty.call(e, r))
      return n = {}, n[r] = e[r], n;
  }), !1));
}
var ce = function(e, t) {
  t === void 0 && (t = mn());
  var r = e.context, n;
  e.type === "page" && (n = e.properties && bn(e.properties, Object.keys(t)), e.properties = d(d(d({}, t), e.properties), e.name ? { name: e.name } : {})), r.page = d(d(d({}, t), n), r.page);
}, wn = (
  /** @class */
  function(e) {
    N(t, e);
    function t(r) {
      var n = e.call(this, {
        createMessageId: function() {
          return "ajs-next-".concat(Date.now(), "-").concat(vt());
        },
        onEventMethodCall: function(i) {
          var o = i.options;
          n.maybeUpdateAnonId(o);
        },
        onFinishedEvent: function(i) {
          return n.addIdentity(i), i;
        }
      }) || this;
      return n.user = r, n;
    }
    return t.prototype.maybeUpdateAnonId = function(r) {
      r != null && r.anonymousId && this.user.anonymousId(r.anonymousId);
    }, t.prototype.addIdentity = function(r) {
      this.user.id() && (r.userId = this.user.id()), this.user.anonymousId() && (r.anonymousId = this.user.anonymousId());
    }, t.prototype.track = function(r, n, i, o, a) {
      var u = e.prototype.track.call(this, r, n, i, o);
      return ce(u, a), u;
    }, t.prototype.page = function(r, n, i, o, a, u) {
      var s = e.prototype.page.call(this, r, n, i, o, a);
      return ce(s, u), s;
    }, t.prototype.screen = function(r, n, i, o, a, u) {
      var s = e.prototype.screen.call(this, r, n, i, o, a);
      return ce(s, u), s;
    }, t.prototype.identify = function(r, n, i, o, a) {
      var u = e.prototype.identify.call(this, r, n, i, o);
      return ce(u, a), u;
    }, t.prototype.group = function(r, n, i, o, a) {
      var u = e.prototype.group.call(this, r, n, i, o);
      return ce(u, a), u;
    }, t.prototype.alias = function(r, n, i, o, a) {
      var u = e.prototype.alias.call(this, r, n, i, o);
      return ce(u, a), u;
    }, t;
  }(Kr)
), _n = function(e) {
  return "addMiddleware" in e && e.type === "destination";
}, B = {
  getItem: function() {
  },
  setItem: function() {
  },
  removeItem: function() {
  }
};
try {
  B = ht() && window.localStorage ? window.localStorage : B;
} catch (e) {
  console.warn("Unable to access localStorage", e);
}
function ar(e) {
  var t = B.getItem(e);
  return (t ? JSON.parse(t) : []).map(function(r) {
    return new Q(r.event, r.id);
  });
}
function Sn(e, t) {
  var r = ar(e), n = D(D([], t, !0), r, !0), i = n.reduce(function(o, a) {
    var u;
    return d(d({}, o), (u = {}, u[a.id] = a, u));
  }, {});
  B.setItem(e, JSON.stringify(Object.values(i)));
}
function ur(e) {
  var t = B.getItem(e);
  return t ? JSON.parse(t) : {};
}
function In(e, t) {
  var r = ur(e);
  B.setItem(e, JSON.stringify(d(d({}, r), t)));
}
function Ut(e) {
  B.removeItem(e);
}
var En = function() {
  return (/* @__PURE__ */ new Date()).getTime();
};
function rt(e, t, r) {
  r === void 0 && (r = 0);
  var n = 50, i = "persisted-queue:v1:".concat(e, ":lock"), o = function(c) {
    return (/* @__PURE__ */ new Date()).getTime() > c;
  }, a = B.getItem(i), u = a ? JSON.parse(a) : null, s = u === null || o(u);
  if (s) {
    B.setItem(i, JSON.stringify(En() + n)), t(), B.removeItem(i);
    return;
  }
  !s && r < 3 ? setTimeout(function() {
    rt(e, t, r + 1);
  }, n) : console.error("Unable to retrieve lock");
}
var gt = (
  /** @class */
  function(e) {
    N(t, e);
    function t(r, n) {
      var i = e.call(this, r, []) || this, o = "persisted-queue:v1:".concat(n, ":items"), a = "persisted-queue:v1:".concat(n, ":seen"), u = [], s = {};
      return rt(n, function() {
        try {
          u = ar(o), s = ur(a), Ut(o), Ut(a), i.queue = D(D([], u, !0), i.queue, !0), i.seen = d(d({}, s), i.seen);
        } catch (c) {
          console.error(c);
        }
      }), window.addEventListener("pagehide", function() {
        if (i.todo > 0) {
          var c = D(D([], i.queue, !0), i.future, !0);
          try {
            rt(n, function() {
              Sn(o, c), In(a, i.seen);
            });
          } catch (l) {
            console.error(l);
          }
        }
      }), i;
    }
    return t;
  }(pt)
), On = (
  /** @class */
  function(e) {
    N(t, e);
    function t(r) {
      return e.call(this, typeof r == "string" ? new gt(4, r) : r) || this;
    }
    return t.prototype.flush = function() {
      return g(this, void 0, void 0, function() {
        return m(this, function(r) {
          return Se() ? [2, []] : [2, e.prototype.flush.call(this)];
        });
      });
    }, t;
  }(nn)
);
function mt(e) {
  for (var t = e.constructor.prototype, r = 0, n = Object.getOwnPropertyNames(t); r < n.length; r++) {
    var i = n[r];
    if (i !== "constructor") {
      var o = Object.getOwnPropertyDescriptor(e.constructor.prototype, i);
      o && typeof o.value == "function" && (e[i] = e[i].bind(e));
    }
  }
  return e;
}
/*! js-cookie v3.0.1 | MIT */
function Me(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];
    for (var n in r)
      e[n] = r[n];
  }
  return e;
}
var Pn = {
  read: function(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(e) {
    return encodeURIComponent(e).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function nt(e, t) {
  function r(i, o, a) {
    if (!(typeof document > "u")) {
      a = Me({}, t, a), typeof a.expires == "number" && (a.expires = new Date(Date.now() + a.expires * 864e5)), a.expires && (a.expires = a.expires.toUTCString()), i = encodeURIComponent(i).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var u = "";
      for (var s in a)
        a[s] && (u += "; " + s, a[s] !== !0 && (u += "=" + a[s].split(";")[0]));
      return document.cookie = i + "=" + e.write(o, i) + u;
    }
  }
  function n(i) {
    if (!(typeof document > "u" || arguments.length && !i)) {
      for (var o = document.cookie ? document.cookie.split("; ") : [], a = {}, u = 0; u < o.length; u++) {
        var s = o[u].split("="), c = s.slice(1).join("=");
        try {
          var l = decodeURIComponent(s[0]);
          if (a[l] = e.read(c, l), i === l)
            break;
        } catch {
        }
      }
      return i ? a[i] : a;
    }
  }
  return Object.create(
    {
      set: r,
      get: n,
      remove: function(i, o) {
        r(
          i,
          "",
          Me({}, o, {
            expires: -1
          })
        );
      },
      withAttributes: function(i) {
        return nt(this.converter, Me({}, this.attributes, i));
      },
      withConverter: function(i) {
        return nt(Me({}, this.converter, i), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(t) },
      converter: { value: Object.freeze(e) }
    }
  );
}
var W = nt(Pn, { path: "/" });
function An(e) {
  var t = e.hostname, r = t.split("."), n = r[r.length - 1], i = [];
  if (r.length === 4 && parseInt(n, 10) > 0 || r.length <= 1)
    return i;
  for (var o = r.length - 2; o >= 0; --o)
    i.push(r.slice(o).join("."));
  return i;
}
function xn(e) {
  try {
    return new URL(e);
  } catch {
    return;
  }
}
function sr(e) {
  var t = xn(e);
  if (t)
    for (var r = An(t), n = 0; n < r.length; ++n) {
      var i = "__tld__", o = r[n], a = { domain: "." + o };
      try {
        if (W.set(i, "1", a), W.get(i))
          return W.remove(i, a), o;
      } catch {
        return;
      }
    }
}
var Mn = 365, cr = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = e.defaults), this.options = d(d({}, e.defaults), t);
    }
    return Object.defineProperty(e, "defaults", {
      get: function() {
        return {
          maxage: Mn,
          domain: sr(window.location.href),
          path: "/",
          sameSite: "Lax"
        };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.opts = function() {
      return {
        sameSite: this.options.sameSite,
        expires: this.options.maxage,
        domain: this.options.domain,
        path: this.options.path,
        secure: this.options.secure
      };
    }, e.prototype.get = function(t) {
      var r;
      try {
        var n = W.get(t);
        if (n == null)
          return null;
        try {
          return (r = JSON.parse(n)) !== null && r !== void 0 ? r : null;
        } catch {
          return n ?? null;
        }
      } catch {
        return null;
      }
    }, e.prototype.set = function(t, r) {
      typeof r == "string" ? W.set(t, r, this.opts()) : r === null ? W.remove(t, this.opts()) : W.set(t, JSON.stringify(r), this.opts());
    }, e.prototype.remove = function(t) {
      return W.remove(t, this.opts());
    }, e;
  }()
), Cn = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.localStorageWarning = function(t, r) {
      console.warn("Unable to access ".concat(t, ", localStorage may be ").concat(r));
    }, e.prototype.get = function(t) {
      var r;
      try {
        var n = localStorage.getItem(t);
        if (n === null)
          return null;
        try {
          return (r = JSON.parse(n)) !== null && r !== void 0 ? r : null;
        } catch {
          return n ?? null;
        }
      } catch {
        return this.localStorageWarning(t, "unavailable"), null;
      }
    }, e.prototype.set = function(t, r) {
      try {
        localStorage.setItem(t, JSON.stringify(r));
      } catch {
        this.localStorageWarning(t, "full");
      }
    }, e.prototype.remove = function(t) {
      try {
        return localStorage.removeItem(t);
      } catch {
        this.localStorageWarning(t, "unavailable");
      }
    }, e;
  }()
), bt = (
  /** @class */
  function() {
    function e() {
      this.cache = {};
    }
    return e.prototype.get = function(t) {
      var r;
      return (r = this.cache[t]) !== null && r !== void 0 ? r : null;
    }, e.prototype.set = function(t, r) {
      this.cache[t] = r;
    }, e.prototype.remove = function(t) {
      delete this.cache[t];
    }, e;
  }()
), j = {
  Cookie: "cookie",
  LocalStorage: "localStorage",
  Memory: "memory"
};
function lr(e) {
  return e && e.stores && Array.isArray(e.stores) && e.stores.every(function(t) {
    return Object.values(j).includes(t);
  });
}
function kn(e) {
  return typeof e == "object" && e.name !== void 0;
}
var Qe = function(e, t, r, n) {
  console.warn("".concat(e.constructor.name, ": Can't ").concat(t, ' key "').concat(r, '" | Err: ').concat(n));
}, re = (
  /** @class */
  function() {
    function e(t) {
      this.stores = t;
    }
    return e.prototype.get = function(t) {
      for (var r = null, n = 0, i = this.stores; n < i.length; n++) {
        var o = i[n];
        try {
          if (r = o.get(t), r != null)
            return r;
        } catch (a) {
          Qe(o, "get", t, a);
        }
      }
      return null;
    }, e.prototype.set = function(t, r) {
      this.stores.forEach(function(n) {
        try {
          n.set(t, r);
        } catch (i) {
          Qe(n, "set", t, i);
        }
      });
    }, e.prototype.clear = function(t) {
      this.stores.forEach(function(r) {
        try {
          r.remove(t);
        } catch (n) {
          Qe(r, "remove", t, n);
        }
      });
    }, e.prototype.getAndSync = function(t) {
      var r = this.get(t), n = typeof r == "number" ? r.toString() : r;
      return this.set(t, n), n;
    }, e;
  }()
);
function it(e) {
  var t = e.map(function(r) {
    var n, i;
    switch (kn(r) ? (n = r.name, i = r.settings) : n = r, n) {
      case j.Cookie:
        return new cr(i);
      case j.LocalStorage:
        return new Cn();
      case j.Memory:
        return new bt();
      default:
        throw new Error("Unknown Store Type: ".concat(r));
    }
  });
  return t;
}
function fr(e, t) {
  return e.map(function(r) {
    return t && r === j.Cookie ? {
      name: r,
      settings: t
    } : r;
  });
}
var ee = {
  persist: !0,
  cookie: {
    key: "ajs_user_id",
    oldKey: "ajs_user"
  },
  localStorage: {
    key: "ajs_user_traits"
  }
}, dr = (
  /** @class */
  function() {
    function e(t, r) {
      t === void 0 && (t = ee);
      var n = this, i, o, a, u;
      this.options = {}, this.id = function(c) {
        if (n.options.disable)
          return null;
        var l = n.identityStore.getAndSync(n.idKey);
        if (c !== void 0) {
          n.identityStore.set(n.idKey, c);
          var f = c !== l && l !== null && c !== null;
          f && n.anonymousId(null);
        }
        var h = n.identityStore.getAndSync(n.idKey);
        if (h)
          return h;
        var v = n.legacyUserStore.get(ee.cookie.oldKey);
        return v ? typeof v == "object" ? v.id : v : null;
      }, this.anonymousId = function(c) {
        var l, f;
        if (n.options.disable)
          return null;
        if (c === void 0) {
          var h = (l = n.identityStore.getAndSync(n.anonKey)) !== null && l !== void 0 ? l : (f = n.legacySIO()) === null || f === void 0 ? void 0 : f[0];
          if (h)
            return h;
        }
        return c === null ? (n.identityStore.set(n.anonKey, null), n.identityStore.getAndSync(n.anonKey)) : (n.identityStore.set(n.anonKey, c ?? vt()), n.identityStore.getAndSync(n.anonKey));
      }, this.traits = function(c) {
        var l;
        if (!n.options.disable)
          return c === null && (c = {}), c && n.traitsStore.set(n.traitsKey, c ?? {}), (l = n.traitsStore.get(n.traitsKey)) !== null && l !== void 0 ? l : {};
      }, this.options = d(d({}, ee), t), this.cookieOptions = r, this.idKey = (o = (i = t.cookie) === null || i === void 0 ? void 0 : i.key) !== null && o !== void 0 ? o : ee.cookie.key, this.traitsKey = (u = (a = t.localStorage) === null || a === void 0 ? void 0 : a.key) !== null && u !== void 0 ? u : ee.localStorage.key, this.anonKey = "ajs_anonymous_id", this.identityStore = this.createStorage(this.options, r), this.legacyUserStore = this.createStorage(this.options, r, function(c) {
        return c === j.Cookie;
      }), this.traitsStore = this.createStorage(this.options, r, function(c) {
        return c !== j.Cookie;
      });
      var s = this.legacyUserStore.get(ee.cookie.oldKey);
      s && typeof s == "object" && (s.id && this.id(s.id), s.traits && this.traits(s.traits)), mt(this);
    }
    return e.prototype.legacySIO = function() {
      var t = this.legacyUserStore.get("_sio");
      if (!t)
        return null;
      var r = t.split("----"), n = r[0], i = r[1];
      return [n, i];
    }, e.prototype.identify = function(t, r) {
      if (!this.options.disable) {
        r = r ?? {};
        var n = this.id();
        (n === null || n === t) && (r = d(d({}, this.traits()), r)), t && this.id(t), this.traits(r);
      }
    }, e.prototype.logout = function() {
      this.anonymousId(null), this.id(null), this.traits({});
    }, e.prototype.reset = function() {
      this.logout(), this.identityStore.clear(this.idKey), this.identityStore.clear(this.anonKey), this.traitsStore.clear(this.traitsKey);
    }, e.prototype.load = function() {
      return new e(this.options, this.cookieOptions);
    }, e.prototype.save = function() {
      return !0;
    }, e.prototype.createStorage = function(t, r, n) {
      var i = [
        j.LocalStorage,
        j.Cookie,
        j.Memory
      ];
      return t.disable ? new re([]) : t.persist ? (t.storage !== void 0 && t.storage !== null && lr(t.storage) && (i = t.storage.stores), t.localStorageFallbackDisabled && (i = i.filter(function(o) {
        return o !== j.LocalStorage;
      })), n && (i = i.filter(n)), new re(it(fr(i, r)))) : new re([new bt()]);
    }, e.defaults = ee, e;
  }()
), zt = {
  persist: !0,
  cookie: {
    key: "ajs_group_id"
  },
  localStorage: {
    key: "ajs_group_properties"
  }
}, Dn = (
  /** @class */
  function(e) {
    N(t, e);
    function t(r, n) {
      r === void 0 && (r = zt);
      var i = e.call(this, d(d({}, zt), r), n) || this;
      return i.anonymousId = function(o) {
      }, mt(i), i;
    }
    return t;
  }(dr)
), wt = "analytics";
function pr() {
  return window[wt];
}
function Fn(e) {
  wt = e;
}
function jn(e) {
  window[wt] = e;
}
var Tn = function(e) {
  return typeof e == "object" && e !== null && "then" in e && typeof e.then == "function";
}, vr = function(e, t, r) {
  r.getAndRemove(e).forEach(function(n) {
    Re(t, n).catch(console.error);
  });
}, Nn = function(e, t) {
  return g(void 0, void 0, void 0, function() {
    var r, n, i;
    return m(this, function(o) {
      switch (o.label) {
        case 0:
          r = 0, n = t.getAndRemove("addSourceMiddleware"), o.label = 1;
        case 1:
          return r < n.length ? (i = n[r], [4, Re(e, i).catch(console.error)]) : [3, 4];
        case 2:
          o.sent(), o.label = 3;
        case 3:
          return r++, [3, 1];
        case 4:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}, Ln = function(e, t) {
  return g(void 0, void 0, void 0, function() {
    var r, n, i;
    return m(this, function(o) {
      switch (o.label) {
        case 0:
          r = 0, n = t.getAndRemove("register"), o.label = 1;
        case 1:
          return r < n.length ? (i = n[r], [4, Re(e, i).catch(console.error)]) : [3, 4];
        case 2:
          o.sent(), o.label = 3;
        case 3:
          return r++, [3, 1];
        case 4:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}, Rn = vr.bind(void 0, "on"), qn = vr.bind(void 0, "setAnonymousId"), $n = function(e, t) {
  Object.keys(t.calls).forEach(function(r) {
    t.getAndRemove(r).forEach(function(n) {
      setTimeout(function() {
        Re(e, n).catch(console.error);
      }, 0);
    });
  });
}, le = function(e) {
  if (hr(e)) {
    var t = e.pop();
    return ir(t);
  }
}, hr = function(e) {
  var t = e[e.length - 1];
  return vn(t);
}, ot = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t, r, n, i) {
      n === void 0 && (n = function() {
      }), i === void 0 && (i = console.error), this.method = t, this.resolve = n, this.reject = i, this.called = !1, this.args = r;
    }
    return e;
  }()
), Un = (
  /** @class */
  function() {
    function e() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      this._callMap = {}, this.add.apply(this, t);
    }
    return Object.defineProperty(e.prototype, "calls", {
      /**
       * Pull any buffered method calls from the window object, and use them to hydrate the instance buffer.
       */
      get: function() {
        return this._pushSnippetWindowBuffer(), this._callMap;
      },
      set: function(t) {
        this._callMap = t;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.get = function(t) {
      var r;
      return (r = this.calls[t]) !== null && r !== void 0 ? r : [];
    }, e.prototype.getAndRemove = function(t) {
      var r = this.get(t);
      return this.calls[t] = [], r;
    }, e.prototype.add = function() {
      for (var t = this, r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      r.forEach(function(i) {
        var o = [
          "track",
          "screen",
          "alias",
          "group",
          "page",
          "identify"
        ];
        o.includes(i.method) && !hr(i.args) && (i.args = D(D([], i.args, !0), [or()], !1)), t.calls[i.method] ? t.calls[i.method].push(i) : t.calls[i.method] = [i];
      });
    }, e.prototype.clear = function() {
      this._pushSnippetWindowBuffer(), this.calls = {};
    }, e.prototype.toArray = function() {
      var t;
      return (t = []).concat.apply(t, Object.values(this.calls));
    }, e.prototype._pushSnippetWindowBuffer = function() {
    }, e;
  }()
);
function Re(e, t) {
  return g(this, void 0, void 0, function() {
    var r, n;
    return m(this, function(i) {
      switch (i.label) {
        case 0:
          return i.trys.push([0, 3, , 4]), t.called ? [2, void 0] : (t.called = !0, r = e[t.method].apply(e, t.args), Tn(r) ? [4, r] : [3, 2]);
        case 1:
          i.sent(), i.label = 2;
        case 2:
          return t.resolve(r), [3, 4];
        case 3:
          return n = i.sent(), t.reject(n), [3, 4];
        case 4:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}
var zn = (
  /** @class */
  function() {
    function e(t) {
      var r = this;
      this.trackSubmit = this._createMethod("trackSubmit"), this.trackClick = this._createMethod("trackClick"), this.trackLink = this._createMethod("trackLink"), this.pageView = this._createMethod("pageview"), this.identify = this._createMethod("identify"), this.reset = this._createMethod("reset"), this.group = this._createMethod("group"), this.track = this._createMethod("track"), this.ready = this._createMethod("ready"), this.alias = this._createMethod("alias"), this.debug = this._createChainableMethod("debug"), this.page = this._createMethod("page"), this.once = this._createChainableMethod("once"), this.off = this._createChainableMethod("off"), this.on = this._createChainableMethod("on"), this.addSourceMiddleware = this._createMethod("addSourceMiddleware"), this.setAnonymousId = this._createMethod("setAnonymousId"), this.addDestinationMiddleware = this._createMethod("addDestinationMiddleware"), this.screen = this._createMethod("screen"), this.register = this._createMethod("register"), this.deregister = this._createMethod("deregister"), this.user = this._createMethod("user"), this.VERSION = Le, this._preInitBuffer = new Un(), this._promise = t(this._preInitBuffer), this._promise.then(function(n) {
        var i = n[0], o = n[1];
        r.instance = i, r.ctx = o;
      }).catch(function() {
      });
    }
    return e.prototype.then = function() {
      for (var t, r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      return (t = this._promise).then.apply(t, r);
    }, e.prototype.catch = function() {
      for (var t, r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      return (t = this._promise).catch.apply(t, r);
    }, e.prototype.finally = function() {
      for (var t, r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      return (t = this._promise).finally.apply(t, r);
    }, e.prototype._createMethod = function(t) {
      var r = this;
      return function() {
        for (var n, i = [], o = 0; o < arguments.length; o++)
          i[o] = arguments[o];
        if (r.instance) {
          var a = (n = r.instance)[t].apply(n, i);
          return Promise.resolve(a);
        }
        return new Promise(function(u, s) {
          r._preInitBuffer.add(new ot(t, i, u, s));
        });
      };
    }, e.prototype._createChainableMethod = function(t) {
      var r = this;
      return function() {
        for (var n, i = [], o = 0; o < arguments.length; o++)
          i[o] = arguments[o];
        return r.instance ? ((n = r.instance)[t].apply(n, i), r) : (r._preInitBuffer.add(new ot(t, i)), r);
      };
    }, e;
  }()
), k = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function jo(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var H = {}, G = {}, _t = {}, yr = { exports: {} };
(function(e) {
  e.exports = t(r), e.exports.find = e.exports, e.exports.replace = function(u, s, c, l) {
    return t(i).call(this, u, s, c, l), u;
  }, e.exports.del = function(u, s, c) {
    return t(n).call(this, u, s, null, c), u;
  };
  function t(u) {
    return function(s, c, l, f) {
      var h = f && a(f.normalizer) ? f.normalizer : o;
      c = h(c);
      for (var v, p = !1; !p; ) y();
      function y() {
        for (v in s) {
          var S = h(v);
          if (c.indexOf(S) === 0) {
            var w = c.substr(S.length);
            if (w.charAt(0) === "." || w.length === 0) {
              c = w.substr(1);
              var I = s[v];
              if (I == null) {
                p = !0;
                return;
              }
              if (!c.length) {
                p = !0;
                return;
              }
              s = I;
              return;
            }
          }
        }
        v = void 0, p = !0;
      }
      if (v)
        return s == null ? s : u(s, v, l);
    };
  }
  function r(u, s) {
    if (u.hasOwnProperty(s)) return u[s];
  }
  function n(u, s) {
    return u.hasOwnProperty(s) && delete u[s], u;
  }
  function i(u, s, c) {
    return u.hasOwnProperty(s) && (u[s] = c), u;
  }
  function o(u) {
    return u.replace(/[^a-zA-Z0-9\.]+/g, "").toLowerCase();
  }
  function a(u) {
    return typeof u == "function";
  }
})(yr);
var qe = yr.exports, Bn = k && k.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(_t, "__esModule", { value: !0 });
var V = Bn(qe);
function fe(e, t) {
  return function() {
    var r = this.traits(), n = this.properties ? this.properties() : {};
    return V.default(r, "address." + e) || V.default(r, e) || (t ? V.default(r, "address." + t) : null) || (t ? V.default(r, t) : null) || V.default(n, "address." + e) || V.default(n, e) || (t ? V.default(n, "address." + t) : null) || (t ? V.default(n, t) : null);
  };
}
function Kn(e) {
  e.zip = fe("postalCode", "zip"), e.country = fe("country"), e.street = fe("street"), e.state = fe("state"), e.city = fe("city"), e.region = fe("region");
}
_t.default = Kn;
var $e = {};
Object.defineProperty($e, "__esModule", { value: !0 });
$e.clone = void 0;
function at(e) {
  if (typeof e != "object")
    return e;
  if (Object.prototype.toString.call(e) === "[object Object]") {
    var t = {};
    for (var r in e)
      Object.prototype.hasOwnProperty.call(e, r) && (t[r] = at(e[r]));
    return t;
  } else return Array.isArray(e) ? e.map(at) : e;
}
$e.clone = at;
var St = {};
Object.defineProperty(St, "__esModule", { value: !0 });
var Gn = {
  Salesforce: !0
};
function Jn(e) {
  return !Gn[e];
}
St.default = Jn;
var Ue = {}, gr = /^(\d{4})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:([ T])(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
Ue.parse = function(e) {
  var t = [1, 5, 6, 7, 11, 12], r = gr.exec(e), n = 0;
  if (!r)
    return new Date(e);
  for (var i = 0, o; o = t[i]; i++)
    r[o] = parseInt(r[o], 10) || 0;
  r[2] = parseInt(r[2], 10) || 1, r[3] = parseInt(r[3], 10) || 1, r[2]--, r[8] = r[8] ? (r[8] + "00").substring(0, 3) : 0, r[4] === " " ? n = (/* @__PURE__ */ new Date()).getTimezoneOffset() : r[9] !== "Z" && r[10] && (n = r[11] * 60 + r[12], r[10] === "+" && (n = 0 - n));
  var a = Date.UTC(r[1], r[2], r[3], r[5], r[6] + n, r[7], r[8]);
  return new Date(a);
};
Ue.is = function(e, t) {
  return typeof e != "string" || t && /^\d{4}-\d{2}-\d{2}/.test(e) === !1 ? !1 : gr.test(e);
};
var It = {}, Wn = /\d{13}/;
It.is = function(e) {
  return Wn.test(e);
};
It.parse = function(e) {
  return e = parseInt(e, 10), new Date(e);
};
var Et = {}, Qn = /\d{10}/;
Et.is = function(e) {
  return Qn.test(e);
};
Et.parse = function(e) {
  var t = parseInt(e, 10) * 1e3;
  return new Date(t);
};
var Bt = Ue, Kt = It, Gt = Et, Vn = Object.prototype, mr = Vn.toString;
function Hn(e) {
  return mr.call(e) === "[object Date]";
}
function Yn(e) {
  return mr.call(e) === "[object Number]";
}
var Ot = function(t) {
  return Hn(t) ? t : Yn(t) ? new Date(Xn(t)) : Bt.is(t) ? Bt.parse(t) : Kt.is(t) ? Kt.parse(t) : Gt.is(t) ? Gt.parse(t) : new Date(t);
};
function Xn(e) {
  return e < 315576e5 ? e * 1e3 : e;
}
var Jt = Ue, Zn = Pt;
function Pt(e, t) {
  return t === void 0 && (t = !0), e && typeof e == "object" ? ei(e, t) : Array.isArray(e) ? ti(e, t) : Jt.is(e, t) ? Jt.parse(e) : e;
}
function ei(e, t) {
  return Object.keys(e).forEach(function(r) {
    e[r] = Pt(e[r], t);
  }), e;
}
function ti(e, t) {
  return e.forEach(function(r, n) {
    e[n] = Pt(r, t);
  }), e;
}
var Ie = k && k.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(G, "__esModule", { value: !0 });
G.Facade = void 0;
var ri = Ie(_t), ye = $e, ni = Ie(St), ii = Ie(Ot), ut = Ie(qe), oi = Ie(Zn);
function L(e, t) {
  t = t || {}, this.raw = ye.clone(e), "clone" in t || (t.clone = !0), t.clone && (e = ye.clone(e)), "traverse" in t || (t.traverse = !0), "timestamp" in e ? e.timestamp = ii.default(e.timestamp) : e.timestamp = /* @__PURE__ */ new Date(), t.traverse && oi.default(e), this.opts = t, this.obj = e;
}
G.Facade = L;
var P = L.prototype;
P.proxy = function(e) {
  var t = e.split(".");
  e = t.shift();
  var r = this[e] || this.obj[e];
  return r && (typeof r == "function" && (r = r.call(this) || {}), t.length === 0 ? this.opts.clone ? st(r) : r : (r = ut.default(r, t.join(".")), this.opts.clone ? st(r) : r));
};
P.field = function(e) {
  var t = this.obj[e];
  return this.opts.clone ? st(t) : t;
};
L.proxy = function(e) {
  return function() {
    return this.proxy(e);
  };
};
L.field = function(e) {
  return function() {
    return this.field(e);
  };
};
L.multi = function(e) {
  return function() {
    var t = this.proxy(e + "s");
    if (Array.isArray(t))
      return t;
    var r = this.proxy(e);
    return r && (r = [this.opts.clone ? ye.clone(r) : r]), r || [];
  };
};
L.one = function(e) {
  return function() {
    var t = this.proxy(e);
    if (t)
      return t;
    var r = this.proxy(e + "s");
    if (Array.isArray(r))
      return r[0];
  };
};
P.json = function() {
  var e = this.opts.clone ? ye.clone(this.obj) : this.obj;
  return this.type && (e.type = this.type()), e;
};
P.rawEvent = function() {
  return this.raw;
};
P.options = function(e) {
  var t = this.obj.options || this.obj.context || {}, r = this.opts.clone ? ye.clone(t) : t;
  if (!e)
    return r;
  if (this.enabled(e)) {
    var n = this.integrations(), i = n[e] || ut.default(n, e);
    return typeof i != "object" && (i = ut.default(this.options(), e)), typeof i == "object" ? i : {};
  }
};
P.context = P.options;
P.enabled = function(e) {
  var t = this.proxy("options.providers.all");
  typeof t != "boolean" && (t = this.proxy("options.all")), typeof t != "boolean" && (t = this.proxy("integrations.all")), typeof t != "boolean" && (t = !0);
  var r = t && ni.default(e), n = this.integrations();
  if (n.providers && n.providers.hasOwnProperty(e) && (r = n.providers[e]), n.hasOwnProperty(e)) {
    var i = n[e];
    typeof i == "boolean" ? r = i : r = !0;
  }
  return !!r;
};
P.integrations = function() {
  return this.obj.integrations || this.proxy("options.providers") || this.options();
};
P.active = function() {
  var e = this.proxy("options.active");
  return e == null && (e = !0), e;
};
P.anonymousId = function() {
  return this.field("anonymousId") || this.field("sessionId");
};
P.sessionId = P.anonymousId;
P.groupId = L.proxy("options.groupId");
P.traits = function(e) {
  var t = this.proxy("options.traits") || {}, r = this.userId();
  e = e || {}, r && (t.id = r);
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      var i = this[n] == null ? this.proxy("options.traits." + n) : this[n]();
      if (i == null)
        continue;
      t[e[n]] = i, delete t[n];
    }
  return t;
};
P.library = function() {
  var e = this.proxy("options.library");
  return e ? typeof e == "string" ? { name: e, version: null } : e : { name: "unknown", version: null };
};
P.device = function() {
  var e = this.proxy("context.device");
  (typeof e != "object" || e === null) && (e = {});
  var t = this.library().name;
  return e.type || (t.indexOf("ios") > -1 && (e.type = "ios"), t.indexOf("android") > -1 && (e.type = "android")), e;
};
P.userAgent = L.proxy("context.userAgent");
P.timezone = L.proxy("context.timezone");
P.timestamp = L.field("timestamp");
P.channel = L.field("channel");
P.ip = L.proxy("context.ip");
P.userId = L.field("userId");
ri.default(P);
function st(e) {
  return ye.clone(e);
}
var ze = {}, ct = { exports: {} };
typeof Object.create == "function" ? ct.exports = function(t, r) {
  r && (t.super_ = r, t.prototype = Object.create(r.prototype, {
    constructor: {
      value: t,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }));
} : ct.exports = function(t, r) {
  if (r) {
    t.super_ = r;
    var n = function() {
    };
    n.prototype = r.prototype, t.prototype = new n(), t.prototype.constructor = t;
  }
};
var ue = ct.exports, ai = k && k.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ze, "__esModule", { value: !0 });
ze.Alias = void 0;
var ui = ai(ue), br = G;
function $(e, t) {
  br.Facade.call(this, e, t);
}
ze.Alias = $;
ui.default($, br.Facade);
$.prototype.action = function() {
  return "alias";
};
$.prototype.type = $.prototype.action;
$.prototype.previousId = function() {
  return this.field("previousId") || this.field("from");
};
$.prototype.from = $.prototype.previousId;
$.prototype.userId = function() {
  return this.field("userId") || this.field("to");
};
$.prototype.to = $.prototype.userId;
var Be = {}, ge = {};
Object.defineProperty(ge, "__esModule", { value: !0 });
var si = /.+\@.+\..+/;
function ci(e) {
  return si.test(e);
}
ge.default = ci;
var At = k && k.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Be, "__esModule", { value: !0 });
Be.Group = void 0;
var li = At(ue), fi = At(ge), di = At(Ot), me = G;
function xt(e, t) {
  me.Facade.call(this, e, t);
}
Be.Group = xt;
li.default(xt, me.Facade);
var U = xt.prototype;
U.action = function() {
  return "group";
};
U.type = U.action;
U.groupId = me.Facade.field("groupId");
U.created = function() {
  var e = this.proxy("traits.createdAt") || this.proxy("traits.created") || this.proxy("properties.createdAt") || this.proxy("properties.created");
  if (e)
    return di.default(e);
};
U.email = function() {
  var e = this.proxy("traits.email");
  if (e)
    return e;
  var t = this.groupId();
  if (fi.default(t))
    return t;
};
U.traits = function(e) {
  var t = this.properties(), r = this.groupId();
  e = e || {}, r && (t.id = r);
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      var i = this[n] == null ? this.proxy("traits." + n) : this[n]();
      if (i == null)
        continue;
      t[e[n]] = i, delete t[n];
    }
  return t;
};
U.name = me.Facade.proxy("traits.name");
U.industry = me.Facade.proxy("traits.industry");
U.employees = me.Facade.proxy("traits.employees");
U.properties = function() {
  return this.field("traits") || this.field("properties") || {};
};
var Ee = {}, Ke = k && k.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ee, "__esModule", { value: !0 });
Ee.Identify = void 0;
var J = G, ve = Ke(qe), pi = Ke(ue), vi = Ke(ge), wr = Ke(Ot), ne = function(e) {
  return e.trim();
};
function Mt(e, t) {
  J.Facade.call(this, e, t);
}
Ee.Identify = Mt;
pi.default(Mt, J.Facade);
var A = Mt.prototype;
A.action = function() {
  return "identify";
};
A.type = A.action;
A.traits = function(e) {
  var t = this.field("traits") || {}, r = this.userId();
  e = e || {}, r && (t.id = r);
  for (var n in e) {
    var i = this[n] == null ? this.proxy("traits." + n) : this[n]();
    i != null && (t[e[n]] = i, n !== e[n] && delete t[n]);
  }
  return t;
};
A.email = function() {
  var e = this.proxy("traits.email");
  if (e)
    return e;
  var t = this.userId();
  if (vi.default(t))
    return t;
};
A.created = function() {
  var e = this.proxy("traits.created") || this.proxy("traits.createdAt");
  if (e)
    return wr.default(e);
};
A.companyCreated = function() {
  var e = this.proxy("traits.company.created") || this.proxy("traits.company.createdAt");
  if (e)
    return wr.default(e);
};
A.companyName = function() {
  return this.proxy("traits.company.name");
};
A.name = function() {
  var e = this.proxy("traits.name");
  if (typeof e == "string")
    return ne(e);
  var t = this.firstName(), r = this.lastName();
  if (t && r)
    return ne(t + " " + r);
};
A.firstName = function() {
  var e = this.proxy("traits.firstName");
  if (typeof e == "string")
    return ne(e);
  var t = this.proxy("traits.name");
  if (typeof t == "string")
    return ne(t).split(" ")[0];
};
A.lastName = function() {
  var e = this.proxy("traits.lastName");
  if (typeof e == "string")
    return ne(e);
  var t = this.proxy("traits.name");
  if (typeof t == "string") {
    var r = ne(t).indexOf(" ");
    if (r !== -1)
      return ne(t.substr(r + 1));
  }
};
A.uid = function() {
  return this.userId() || this.username() || this.email();
};
A.description = function() {
  return this.proxy("traits.description") || this.proxy("traits.background");
};
A.age = function() {
  var e = this.birthday(), t = ve.default(this.traits(), "age");
  if (t != null)
    return t;
  if (e instanceof Date) {
    var r = /* @__PURE__ */ new Date();
    return r.getFullYear() - e.getFullYear();
  }
};
A.avatar = function() {
  var e = this.traits();
  return ve.default(e, "avatar") || ve.default(e, "photoUrl") || ve.default(e, "avatarUrl");
};
A.position = function() {
  var e = this.traits();
  return ve.default(e, "position") || ve.default(e, "jobTitle");
};
A.username = J.Facade.proxy("traits.username");
A.website = J.Facade.one("traits.website");
A.websites = J.Facade.multi("traits.website");
A.phone = J.Facade.one("traits.phone");
A.phones = J.Facade.multi("traits.phone");
A.address = J.Facade.proxy("traits.address");
A.gender = J.Facade.proxy("traits.gender");
A.birthday = J.Facade.proxy("traits.birthday");
var be = {}, Ct = k && k.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(be, "__esModule", { value: !0 });
be.Track = void 0;
var hi = Ct(ue), F = G, yi = Ee, gi = Ct(ge), _r = Ct(qe);
function kt(e, t) {
  F.Facade.call(this, e, t);
}
be.Track = kt;
hi.default(kt, F.Facade);
var _ = kt.prototype;
_.action = function() {
  return "track";
};
_.type = _.action;
_.event = F.Facade.field("event");
_.value = F.Facade.proxy("properties.value");
_.category = F.Facade.proxy("properties.category");
_.id = F.Facade.proxy("properties.id");
_.productId = function() {
  return this.proxy("properties.product_id") || this.proxy("properties.productId");
};
_.promotionId = function() {
  return this.proxy("properties.promotion_id") || this.proxy("properties.promotionId");
};
_.cartId = function() {
  return this.proxy("properties.cart_id") || this.proxy("properties.cartId");
};
_.checkoutId = function() {
  return this.proxy("properties.checkout_id") || this.proxy("properties.checkoutId");
};
_.paymentId = function() {
  return this.proxy("properties.payment_id") || this.proxy("properties.paymentId");
};
_.couponId = function() {
  return this.proxy("properties.coupon_id") || this.proxy("properties.couponId");
};
_.wishlistId = function() {
  return this.proxy("properties.wishlist_id") || this.proxy("properties.wishlistId");
};
_.reviewId = function() {
  return this.proxy("properties.review_id") || this.proxy("properties.reviewId");
};
_.orderId = function() {
  return this.proxy("properties.id") || this.proxy("properties.order_id") || this.proxy("properties.orderId");
};
_.sku = F.Facade.proxy("properties.sku");
_.tax = F.Facade.proxy("properties.tax");
_.name = F.Facade.proxy("properties.name");
_.price = F.Facade.proxy("properties.price");
_.total = F.Facade.proxy("properties.total");
_.repeat = F.Facade.proxy("properties.repeat");
_.coupon = F.Facade.proxy("properties.coupon");
_.shipping = F.Facade.proxy("properties.shipping");
_.discount = F.Facade.proxy("properties.discount");
_.shippingMethod = function() {
  return this.proxy("properties.shipping_method") || this.proxy("properties.shippingMethod");
};
_.paymentMethod = function() {
  return this.proxy("properties.payment_method") || this.proxy("properties.paymentMethod");
};
_.description = F.Facade.proxy("properties.description");
_.plan = F.Facade.proxy("properties.plan");
_.subtotal = function() {
  var e = _r.default(this.properties(), "subtotal"), t = this.total() || this.revenue();
  if (e)
    return e;
  if (!t)
    return 0;
  if (this.total()) {
    var r = this.tax();
    r && (t -= r), r = this.shipping(), r && (t -= r), r = this.discount(), r && (t += r);
  }
  return t;
};
_.products = function() {
  var e = this.properties(), t = _r.default(e, "products");
  return Array.isArray(t) ? t.filter(function(r) {
    return r !== null;
  }) : [];
};
_.quantity = function() {
  var e = this.obj.properties || {};
  return e.quantity || 1;
};
_.currency = function() {
  var e = this.obj.properties || {};
  return e.currency || "USD";
};
_.referrer = function() {
  return this.proxy("context.referrer.url") || this.proxy("context.page.referrer") || this.proxy("properties.referrer");
};
_.query = F.Facade.proxy("options.query");
_.properties = function(e) {
  var t = this.field("properties") || {};
  e = e || {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      var n = this[r] == null ? this.proxy("properties." + r) : this[r]();
      if (n == null)
        continue;
      t[e[r]] = n, delete t[r];
    }
  return t;
};
_.username = function() {
  return this.proxy("traits.username") || this.proxy("properties.username") || this.userId() || this.sessionId();
};
_.email = function() {
  var e = this.proxy("traits.email") || this.proxy("properties.email") || this.proxy("options.traits.email");
  if (e)
    return e;
  var t = this.userId();
  if (gi.default(t))
    return t;
};
_.revenue = function() {
  var e = this.proxy("properties.revenue"), t = this.event(), r = /^[ _]?completed[ _]?order[ _]?|^[ _]?order[ _]?completed[ _]?$/i;
  return !e && t && t.match(r) && (e = this.proxy("properties.total")), mi(e);
};
_.cents = function() {
  var e = this.revenue();
  return typeof e != "number" ? this.value() || 0 : e * 100;
};
_.identify = function() {
  var e = this.json();
  return e.traits = this.traits(), new yi.Identify(e, this.opts);
};
function mi(e) {
  if (e) {
    if (typeof e == "number")
      return e;
    if (typeof e == "string" && (e = e.replace(/\$/g, ""), e = parseFloat(e), !isNaN(e)))
      return e;
  }
}
var Oe = {}, Sr = k && k.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Oe, "__esModule", { value: !0 });
Oe.Page = void 0;
var bi = Sr(ue), se = G, wi = be, _i = Sr(ge);
function Dt(e, t) {
  se.Facade.call(this, e, t);
}
Oe.Page = Dt;
bi.default(Dt, se.Facade);
var T = Dt.prototype;
T.action = function() {
  return "page";
};
T.type = T.action;
T.category = se.Facade.field("category");
T.name = se.Facade.field("name");
T.title = se.Facade.proxy("properties.title");
T.path = se.Facade.proxy("properties.path");
T.url = se.Facade.proxy("properties.url");
T.referrer = function() {
  return this.proxy("context.referrer.url") || this.proxy("context.page.referrer") || this.proxy("properties.referrer");
};
T.properties = function(e) {
  var t = this.field("properties") || {}, r = this.category(), n = this.name();
  e = e || {}, r && (t.category = r), n && (t.name = n);
  for (var i in e)
    if (Object.prototype.hasOwnProperty.call(e, i)) {
      var o = this[i] == null ? this.proxy("properties." + i) : this[i]();
      if (o == null)
        continue;
      t[e[i]] = o, i !== e[i] && delete t[i];
    }
  return t;
};
T.email = function() {
  var e = this.proxy("context.traits.email") || this.proxy("properties.email");
  if (e)
    return e;
  var t = this.userId();
  if (_i.default(t))
    return t;
};
T.fullName = function() {
  var e = this.category(), t = this.name();
  return t && e ? e + " " + t : t;
};
T.event = function(e) {
  return e ? "Viewed " + e + " Page" : "Loaded a Page";
};
T.track = function(e) {
  var t = this.json();
  return t.event = this.event(e), t.timestamp = this.timestamp(), t.properties = this.properties(), new wi.Track(t, this.opts);
};
var Ge = {}, Si = k && k.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ge, "__esModule", { value: !0 });
Ge.Screen = void 0;
var Ii = Si(ue), Ir = Oe, Ei = be;
function oe(e, t) {
  Ir.Page.call(this, e, t);
}
Ge.Screen = oe;
Ii.default(oe, Ir.Page);
oe.prototype.action = function() {
  return "screen";
};
oe.prototype.type = oe.prototype.action;
oe.prototype.event = function(e) {
  return e ? "Viewed " + e + " Screen" : "Loaded a Screen";
};
oe.prototype.track = function(e) {
  var t = this.json();
  return t.event = this.event(e), t.timestamp = this.timestamp(), t.properties = this.properties(), new Ei.Track(t, this.opts);
};
var Je = {}, Oi = k && k.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Je, "__esModule", { value: !0 });
Je.Delete = void 0;
var Pi = Oi(ue), Er = G;
function Ft(e, t) {
  Er.Facade.call(this, e, t);
}
Je.Delete = Ft;
Pi.default(Ft, Er.Facade);
Ft.prototype.type = function() {
  return "delete";
};
(function(e) {
  var t = k && k.__assign || function() {
    return t = Object.assign || function(l) {
      for (var f, h = 1, v = arguments.length; h < v; h++) {
        f = arguments[h];
        for (var p in f) Object.prototype.hasOwnProperty.call(f, p) && (l[p] = f[p]);
      }
      return l;
    }, t.apply(this, arguments);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Delete = e.Screen = e.Page = e.Track = e.Identify = e.Group = e.Alias = e.Facade = void 0;
  var r = G;
  Object.defineProperty(e, "Facade", { enumerable: !0, get: function() {
    return r.Facade;
  } });
  var n = ze;
  Object.defineProperty(e, "Alias", { enumerable: !0, get: function() {
    return n.Alias;
  } });
  var i = Be;
  Object.defineProperty(e, "Group", { enumerable: !0, get: function() {
    return i.Group;
  } });
  var o = Ee;
  Object.defineProperty(e, "Identify", { enumerable: !0, get: function() {
    return o.Identify;
  } });
  var a = be;
  Object.defineProperty(e, "Track", { enumerable: !0, get: function() {
    return a.Track;
  } });
  var u = Oe;
  Object.defineProperty(e, "Page", { enumerable: !0, get: function() {
    return u.Page;
  } });
  var s = Ge;
  Object.defineProperty(e, "Screen", { enumerable: !0, get: function() {
    return s.Screen;
  } });
  var c = Je;
  Object.defineProperty(e, "Delete", { enumerable: !0, get: function() {
    return c.Delete;
  } }), e.default = t(t({}, r.Facade), {
    Alias: n.Alias,
    Group: i.Group,
    Identify: o.Identify,
    Track: a.Track,
    Page: u.Page,
    Screen: s.Screen,
    Delete: c.Delete
  });
})(H);
function je(e, t) {
  var r = new H.Facade(e, t);
  return e.type === "track" && (r = new H.Track(e, t)), e.type === "identify" && (r = new H.Identify(e, t)), e.type === "page" && (r = new H.Page(e, t)), e.type === "alias" && (r = new H.Alias(e, t)), e.type === "group" && (r = new H.Group(e, t)), e.type === "screen" && (r = new H.Screen(e, t)), Object.defineProperty(r, "obj", {
    value: e,
    writable: !0
  }), r;
}
var Ai = function(e) {
  var t = !1;
  window.addEventListener("pagehide", function() {
    t || (t = !0, e(t));
  }), document.addEventListener("visibilitychange", function() {
    if (document.visibilityState == "hidden") {
      if (t)
        return;
      t = !0;
    } else
      t = !1;
    e(t);
  });
}, Or = (
  /** @class */
  function(e) {
    N(t, e);
    function t(r, n) {
      var i = e.call(this, r) || this;
      return i.retryTimeout = n, i.name = "RateLimitError", i;
    }
    return t;
  }(Error)
), xi = 500, Mi = 64;
function jt(e) {
  var t = encodeURI(JSON.stringify(e)).split(/%..|./).length - 1;
  return t / 1024;
}
function Ci(e) {
  return jt(e) >= xi - 50;
}
function ki(e) {
  return jt(e) >= Mi - 10;
}
function Di(e) {
  var t = [], r = 0;
  return e.forEach(function(n) {
    var i = jt(t[r]);
    i >= 64 && r++, t[r] ? t[r].push(n) : t[r] = [n];
  }), t;
}
function Fi(e, t) {
  var r, n, i = [], o = !1, a = (r = t == null ? void 0 : t.size) !== null && r !== void 0 ? r : 10, u = (n = t == null ? void 0 : t.timeout) !== null && n !== void 0 ? n : 5e3, s = 0;
  function c(p) {
    var y;
    if (p.length !== 0) {
      var S = (y = p[0]) === null || y === void 0 ? void 0 : y.writeKey, w = p.map(function(I) {
        var b = I;
        b.sentAt;
        var M = Ht(b, ["sentAt"]);
        return M;
      });
      return Ne("https://".concat(e, "/b"), {
        keepalive: (t == null ? void 0 : t.keepalive) || o,
        headers: {
          "Content-Type": "text/plain"
        },
        method: "post",
        body: JSON.stringify({
          writeKey: S,
          batch: w,
          sentAt: (/* @__PURE__ */ new Date()).toISOString()
        })
      }).then(function(I) {
        var b;
        if (I.status >= 500)
          throw new Error("Bad response from server: ".concat(I.status));
        if (I.status === 429) {
          var M = (b = I.headers) === null || b === void 0 ? void 0 : b.get("x-ratelimit-reset"), O = typeof M == "string" ? parseInt(M) * 1e3 : u;
          throw new Or("Rate limit exceeded: ".concat(I.status), O);
        }
      });
    }
  }
  function l(p) {
    var y;
    return p === void 0 && (p = 1), g(this, void 0, void 0, function() {
      var S;
      return m(this, function(w) {
        return i.length ? (S = i, i = [], [2, (y = c(S)) === null || y === void 0 ? void 0 : y.catch(function(I) {
          var b, M = Q.system();
          M.log("error", "Error sending batch", I), p <= ((b = t == null ? void 0 : t.maxRetries) !== null && b !== void 0 ? b : 10) && (I.name === "RateLimitError" && (s = I.retryTimeout), i.push.apply(i, S), i.map(function(O) {
            if ("_metadata" in O) {
              var x = O;
              x._metadata = d(d({}, x._metadata), { retryCount: p });
            }
          }), h(p + 1));
        })]) : [
          2
          /*return*/
        ];
      });
    });
  }
  var f;
  function h(p) {
    p === void 0 && (p = 1), !f && (f = setTimeout(function() {
      f = void 0, l(p).catch(console.error);
    }, s || u), s = 0);
  }
  Ai(function(p) {
    if (o = p, o && i.length) {
      var y = Di(i).map(c);
      Promise.all(y).catch(console.error);
    }
  });
  function v(p, y) {
    return g(this, void 0, void 0, function() {
      var S;
      return m(this, function(w) {
        return i.push(y), S = i.length >= a || Ci(i) || (t == null ? void 0 : t.keepalive) && ki(i), [2, S || o ? l() : h()];
      });
    });
  }
  return {
    dispatch: v
  };
}
function ji(e) {
  function t(r, n) {
    return Ne(r, {
      keepalive: e == null ? void 0 : e.keepalive,
      headers: { "Content-Type": "text/plain" },
      method: "post",
      body: JSON.stringify(n)
    }).then(function(i) {
      var o;
      if (i.status >= 500)
        throw new Error("Bad response from server: ".concat(i.status));
      if (i.status === 429) {
        var a = (o = i.headers) === null || o === void 0 ? void 0 : o.get("x-ratelimit-reset"), u = a ? parseInt(a) * 1e3 : 5e3;
        throw new Or("Rate limit exceeded: ".concat(i.status), u);
      }
    });
  }
  return {
    dispatch: t
  };
}
function Ti(e, t, r, n, i) {
  var o, a = e.user();
  delete t.options, t.writeKey = r == null ? void 0 : r.apiKey, t.userId = t.userId || a.id(), t.anonymousId = t.anonymousId || a.anonymousId(), t.sentAt = /* @__PURE__ */ new Date();
  var u = e.queue.failedInitializations || [];
  u.length > 0 && (t._metadata = { failedInitializations: u }), i != null && (i.attempts > 1 && (t._metadata = d(d({}, t._metadata), { retryCount: i.attempts })), i.attempts++);
  var s = [], c = [];
  for (var l in n) {
    var f = n[l];
    l === "Segment.io" && s.push(l), f.bundlingStatus === "bundled" && s.push(l), f.bundlingStatus === "unbundled" && c.push(l);
  }
  for (var h = 0, v = (r == null ? void 0 : r.unbundledIntegrations) || []; h < v.length; h++) {
    var p = v[h];
    c.includes(p) || c.push(p);
  }
  var y = (o = r == null ? void 0 : r.maybeBundledConfigIds) !== null && o !== void 0 ? o : {}, S = [];
  return s.sort().forEach(function(w) {
    var I;
    ((I = y[w]) !== null && I !== void 0 ? I : []).forEach(function(b) {
      S.push(b);
    });
  }), (r == null ? void 0 : r.addBundledMetadata) !== !1 && (t._metadata = d(d({}, t._metadata), { bundled: s.sort(), unbundled: c.sort(), bundledIds: S })), t;
}
var Ni = function(e, t) {
  return g(void 0, void 0, void 0, function() {
    var r;
    return m(this, function(n) {
      return r = function(i) {
        return g(void 0, void 0, void 0, function() {
          var o;
          return m(this, function(a) {
            switch (a.label) {
              case 0:
                return e(i) ? (o = r, [4, t()]) : [3, 2];
              case 1:
                return [2, o.apply(void 0, [a.sent()])];
              case 2:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, [2, r(void 0)];
    });
  });
};
function Li(e, t) {
  return g(this, void 0, void 0, function() {
    var r, n = this;
    return m(this, function(i) {
      switch (i.label) {
        case 0:
          return r = [], Se() ? [2, t] : [
            4,
            Ni(function() {
              return t.length > 0 && !Se();
            }, function() {
              return g(n, void 0, void 0, function() {
                var o, a, u;
                return m(this, function(s) {
                  switch (s.label) {
                    case 0:
                      return o = t.pop(), o ? [4, _e(o, e)] : [
                        2
                        /*return*/
                      ];
                    case 1:
                      return a = s.sent(), u = a instanceof Q, u || r.push(o), [
                        2
                        /*return*/
                      ];
                  }
                });
              });
            })
            // re-add failed tasks
          ];
        case 1:
          return i.sent(), r.map(function(o) {
            return t.pushWithBackoff(o);
          }), [2, t];
      }
    });
  });
}
function de(e, t, r, n) {
  var i = this;
  e || setTimeout(function() {
    return g(i, void 0, void 0, function() {
      var o, a;
      return m(this, function(u) {
        switch (u.label) {
          case 0:
            return o = !0, [4, Li(r, t)];
          case 1:
            return a = u.sent(), o = !1, t.todo > 0 && n(o, a, r, n), [
              2
              /*return*/
            ];
        }
      });
    });
  }, Math.random() * 5e3);
}
function Ri(e, t) {
  var r, n, i, o, a = e.user();
  return t.previousId = (i = (n = (r = t.previousId) !== null && r !== void 0 ? r : t.from) !== null && n !== void 0 ? n : a.id()) !== null && i !== void 0 ? i : a.anonymousId(), t.userId = (o = t.userId) !== null && o !== void 0 ? o : t.to, delete t.from, delete t.to, t;
}
var qi = function(e) {
  return e.name === "Segment.io";
};
function $i(e, t, r) {
  var n, i, o;
  window.addEventListener("pagehide", function() {
    u.push.apply(u, Array.from(s)), s.clear();
  });
  var a = (n = t == null ? void 0 : t.apiKey) !== null && n !== void 0 ? n : "", u = e.options.disableClientPersistence ? new pt(e.queue.queue.maxAttempts, []) : new gt(e.queue.queue.maxAttempts, "".concat(a, ":dest-Segment.io")), s = /* @__PURE__ */ new Set(), c = !1, l = (i = t == null ? void 0 : t.apiHost) !== null && i !== void 0 ? i : er, f = (o = t == null ? void 0 : t.protocol) !== null && o !== void 0 ? o : "https", h = "".concat(f, "://").concat(l), v = t == null ? void 0 : t.deliveryStrategy, p = (v == null ? void 0 : v.strategy) === "batching" ? Fi(l, v.config) : ji(v == null ? void 0 : v.config);
  function y(w) {
    return g(this, void 0, void 0, function() {
      var I, b;
      return m(this, function(M) {
        return Se() ? (u.push(w), de(c, u, S, de), [2, w]) : (s.add(w), I = w.event.type.charAt(0), b = je(w.event).json(), w.event.type === "track" && delete b.traits, w.event.type === "alias" && (b = Ri(e, b)), [2, p.dispatch("".concat(h, "/").concat(I), Ti(e, b, t, r, w)).then(function() {
          return w;
        }).catch(function(O) {
          if (w.log("error", "Error sending event", O), O.name === "RateLimitError") {
            var x = O.retryTimeout;
            u.pushWithBackoff(w, x);
          } else
            u.pushWithBackoff(w);
          return de(c, u, S, de), w;
        }).finally(function() {
          s.delete(w);
        })]);
      });
    });
  }
  var S = {
    metadata: {
      writeKey: a,
      apiHost: l,
      protocol: f
    },
    name: "Segment.io",
    type: "destination",
    version: "0.1.0",
    isLoaded: function() {
      return !0;
    },
    load: function() {
      return Promise.resolve();
    },
    track: y,
    identify: y,
    page: y,
    alias: y,
    group: y,
    screen: y
  };
  return u.todo && de(c, u, S, de), S;
}
var Y = "This is being deprecated and will be not be available in future releases of Analytics JS", Ve = yt(), He = Ve == null ? void 0 : Ve.analytics;
function Ui(e, t, r) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  var n = t ? 10 : 1, i = r ? new pt(n, []) : new gt(n, e);
  return new On(i);
}
var zi = (
  /** @class */
  function() {
    function e(t, r) {
      var n;
      this.timeout = 300, this._getSegmentPluginMetadata = function() {
        var i;
        return (i = r.plugins.find(qi)) === null || i === void 0 ? void 0 : i.metadata;
      }, this.writeKey = t.writeKey, this.cdnSettings = (n = t.cdnSettings) !== null && n !== void 0 ? n : {
        integrations: {},
        edgeFunction: {}
      }, this.cdnURL = t.cdnURL;
    }
    return Object.defineProperty(e.prototype, "apiHost", {
      get: function() {
        var t, r;
        return (r = (t = this._getSegmentPluginMetadata) === null || t === void 0 ? void 0 : t.call(this)) === null || r === void 0 ? void 0 : r.apiHost;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }()
);
function z() {
  console.warn(Y);
}
var Pr = (
  /** @class */
  function(e) {
    N(t, e);
    function t(r, n, i, o, a) {
      var u = this, s, c;
      u = e.call(this) || this, u._debug = !1, u.initialized = !1, u.user = function() {
        return u._user;
      }, u.init = u.initialize.bind(u), u.log = z, u.addIntegrationMiddleware = z, u.listeners = z, u.addEventListener = z, u.removeAllListeners = z, u.removeListener = z, u.removeEventListener = z, u.hasListeners = z, u.add = z, u.addIntegration = z;
      var l = n == null ? void 0 : n.cookie, f = (s = n == null ? void 0 : n.disableClientPersistence) !== null && s !== void 0 ? s : !1;
      u.queue = i ?? Ui("".concat(r.writeKey, ":event-queue"), n == null ? void 0 : n.retryQueue, f), u.settings = new zi(r, u.queue);
      var h = n == null ? void 0 : n.storage;
      return u._universalStorage = u.createStore(f, h, l), u._user = o ?? new dr(d({ persist: !f, storage: n == null ? void 0 : n.storage }, n == null ? void 0 : n.user), l).load(), u._group = a ?? new Dn(d({ persist: !f, storage: n == null ? void 0 : n.storage }, n == null ? void 0 : n.group), l).load(), u.eventFactory = new wn(u._user), u.integrations = (c = n == null ? void 0 : n.integrations) !== null && c !== void 0 ? c : {}, u.options = n ?? {}, mt(u), u;
    }
    return t.prototype.createStore = function(r, n, i) {
      return r ? new re([new bt()]) : n && lr(n) ? new re(it(fr(n.stores, i))) : new re(it([
        j.LocalStorage,
        {
          name: j.Cookie,
          settings: i
        },
        j.Memory
      ]));
    }, Object.defineProperty(t.prototype, "storage", {
      get: function() {
        return this._universalStorage;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.track = function() {
      for (var r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      return g(this, void 0, void 0, function() {
        var i, o, a, u, s, c, l, f = this;
        return m(this, function(h) {
          return i = le(r), o = un.apply(void 0, r), a = o[0], u = o[1], s = o[2], c = o[3], l = this.eventFactory.track(a, u, s, this.integrations, i), [2, this._dispatch(l, c).then(function(v) {
            return f.emit("track", a, v.event.properties, v.event.options), v;
          })];
        });
      });
    }, t.prototype.page = function() {
      for (var r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      return g(this, void 0, void 0, function() {
        var i, o, a, u, s, c, l, f, h = this;
        return m(this, function(v) {
          return i = le(r), o = qt.apply(void 0, r), a = o[0], u = o[1], s = o[2], c = o[3], l = o[4], f = this.eventFactory.page(a, u, s, c, this.integrations, i), [2, this._dispatch(f, l).then(function(p) {
            return h.emit("page", a, u, p.event.properties, p.event.options), p;
          })];
        });
      });
    }, t.prototype.identify = function() {
      for (var r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      return g(this, void 0, void 0, function() {
        var i, o, a, u, s, c, l, f = this;
        return m(this, function(h) {
          return i = le(r), o = $t(this._user).apply(void 0, r), a = o[0], u = o[1], s = o[2], c = o[3], this._user.identify(a, u), l = this.eventFactory.identify(this._user.id(), this._user.traits(), s, this.integrations, i), [2, this._dispatch(l, c).then(function(v) {
            return f.emit("identify", v.event.userId, v.event.traits, v.event.options), v;
          })];
        });
      });
    }, t.prototype.group = function() {
      for (var r = this, n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      var o = le(n);
      if (n.length === 0)
        return this._group;
      var a = $t(this._group).apply(void 0, n), u = a[0], s = a[1], c = a[2], l = a[3];
      this._group.identify(u, s);
      var f = this._group.id(), h = this._group.traits(), v = this.eventFactory.group(f, h, c, this.integrations, o);
      return this._dispatch(v, l).then(function(p) {
        return r.emit("group", p.event.groupId, p.event.traits, p.event.options), p;
      });
    }, t.prototype.alias = function() {
      for (var r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      return g(this, void 0, void 0, function() {
        var i, o, a, u, s, c, l, f = this;
        return m(this, function(h) {
          return i = le(r), o = sn.apply(void 0, r), a = o[0], u = o[1], s = o[2], c = o[3], l = this.eventFactory.alias(a, u, s, this.integrations, i), [2, this._dispatch(l, c).then(function(v) {
            return f.emit("alias", a, u, v.event.options), v;
          })];
        });
      });
    }, t.prototype.screen = function() {
      for (var r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      return g(this, void 0, void 0, function() {
        var i, o, a, u, s, c, l, f, h = this;
        return m(this, function(v) {
          return i = le(r), o = qt.apply(void 0, r), a = o[0], u = o[1], s = o[2], c = o[3], l = o[4], f = this.eventFactory.screen(a, u, s, c, this.integrations, i), [2, this._dispatch(f, l).then(function(p) {
            return h.emit("screen", a, u, p.event.properties, p.event.options), p;
          })];
        });
      });
    }, t.prototype.trackClick = function() {
      for (var r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      return g(this, void 0, void 0, function() {
        var i, o;
        return m(this, function(a) {
          switch (a.label) {
            case 0:
              return [4, import(
                /* webpackChunkName: "auto-track" */
                "./auto-track-BOa4yZTl.js"
              )];
            case 1:
              return i = a.sent(), [2, (o = i.link).call.apply(o, D([this], r, !1))];
          }
        });
      });
    }, t.prototype.trackLink = function() {
      for (var r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      return g(this, void 0, void 0, function() {
        var i, o;
        return m(this, function(a) {
          switch (a.label) {
            case 0:
              return [4, import(
                /* webpackChunkName: "auto-track" */
                "./auto-track-BOa4yZTl.js"
              )];
            case 1:
              return i = a.sent(), [2, (o = i.link).call.apply(o, D([this], r, !1))];
          }
        });
      });
    }, t.prototype.trackSubmit = function() {
      for (var r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      return g(this, void 0, void 0, function() {
        var i, o;
        return m(this, function(a) {
          switch (a.label) {
            case 0:
              return [4, import(
                /* webpackChunkName: "auto-track" */
                "./auto-track-BOa4yZTl.js"
              )];
            case 1:
              return i = a.sent(), [2, (o = i.form).call.apply(o, D([this], r, !1))];
          }
        });
      });
    }, t.prototype.trackForm = function() {
      for (var r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      return g(this, void 0, void 0, function() {
        var i, o;
        return m(this, function(a) {
          switch (a.label) {
            case 0:
              return [4, import(
                /* webpackChunkName: "auto-track" */
                "./auto-track-BOa4yZTl.js"
              )];
            case 1:
              return i = a.sent(), [2, (o = i.form).call.apply(o, D([this], r, !1))];
          }
        });
      });
    }, t.prototype.register = function() {
      for (var r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      return g(this, void 0, void 0, function() {
        var i, o, a = this;
        return m(this, function(u) {
          switch (u.label) {
            case 0:
              return i = Q.system(), o = r.map(function(s) {
                return a.queue.register(i, s, a);
              }), [4, Promise.all(o)];
            case 1:
              return u.sent(), [2, i];
          }
        });
      });
    }, t.prototype.deregister = function() {
      for (var r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      return g(this, void 0, void 0, function() {
        var i, o, a = this;
        return m(this, function(u) {
          switch (u.label) {
            case 0:
              return i = Q.system(), o = r.map(function(s) {
                var c = a.queue.plugins.find(function(l) {
                  return l.name === s;
                });
                if (c)
                  return a.queue.deregister(i, c, a);
                i.log("warn", "plugin ".concat(s, " not found"));
              }), [4, Promise.all(o)];
            case 1:
              return u.sent(), [2, i];
          }
        });
      });
    }, t.prototype.debug = function(r) {
      return r === !1 && localStorage.getItem("debug") && localStorage.removeItem("debug"), this._debug = r, this;
    }, t.prototype.reset = function() {
      this._user.reset(), this._group.reset(), this.emit("reset");
    }, t.prototype.timeout = function(r) {
      this.settings.timeout = r;
    }, t.prototype._dispatch = function(r, n) {
      return g(this, void 0, void 0, function() {
        var i;
        return m(this, function(o) {
          return i = new Q(r), Se() && !this.options.retryQueue ? [2, i] : [2, an(i, this.queue, this, {
            callback: n,
            debug: this._debug,
            timeout: this.settings.timeout
          })];
        });
      });
    }, t.prototype.addSourceMiddleware = function(r) {
      return g(this, void 0, void 0, function() {
        var n = this;
        return m(this, function(i) {
          switch (i.label) {
            case 0:
              return [4, this.queue.criticalTasks.run(function() {
                return g(n, void 0, void 0, function() {
                  var o, a, u;
                  return m(this, function(s) {
                    switch (s.label) {
                      case 0:
                        return [4, Promise.resolve().then(() => oo)];
                      case 1:
                        return o = s.sent().sourceMiddlewarePlugin, a = {}, this.queue.plugins.forEach(function(c) {
                          if (c.type === "destination")
                            return a[c.name] = !0;
                        }), u = o(r, a), [4, this.register(u)];
                      case 2:
                        return s.sent(), [
                          2
                          /*return*/
                        ];
                    }
                  });
                });
              })];
            case 1:
              return i.sent(), [2, this];
          }
        });
      });
    }, t.prototype.addDestinationMiddleware = function(r) {
      for (var n = [], i = 1; i < arguments.length; i++)
        n[i - 1] = arguments[i];
      return this.queue.plugins.filter(_n).forEach(function(o) {
        (r === "*" || o.name.toLowerCase() === r.toLowerCase()) && o.addMiddleware.apply(o, n);
      }), Promise.resolve(this);
    }, t.prototype.setAnonymousId = function(r) {
      return this._user.anonymousId(r);
    }, t.prototype.queryString = function(r) {
      return g(this, void 0, void 0, function() {
        var n;
        return m(this, function(i) {
          switch (i.label) {
            case 0:
              return this.options.useQueryString === !1 ? [2, []] : [4, import(
                /* webpackChunkName: "queryString" */
                "./index-DNoyfGer.js"
              )];
            case 1:
              return n = i.sent().queryString, [2, n(this, r)];
          }
        });
      });
    }, t.prototype.use = function(r) {
      return r(this), this;
    }, t.prototype.ready = function(r) {
      return r === void 0 && (r = function(n) {
        return n;
      }), g(this, void 0, void 0, function() {
        return m(this, function(n) {
          return [2, Promise.all(this.queue.plugins.map(function(i) {
            return i.ready ? i.ready() : Promise.resolve();
          })).then(function(i) {
            return r(i), i;
          })];
        });
      });
    }, t.prototype.noConflict = function() {
      return console.warn(Y), jn(He ?? this), this;
    }, t.prototype.normalize = function(r) {
      return console.warn(Y), this.eventFactory.normalize(r);
    }, Object.defineProperty(t.prototype, "failedInitializations", {
      get: function() {
        return console.warn(Y), this.queue.failedInitializations;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "VERSION", {
      get: function() {
        return Le;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.initialize = function(r, n) {
      return g(this, void 0, void 0, function() {
        return m(this, function(i) {
          return console.warn(Y), [2, Promise.resolve(this)];
        });
      });
    }, t.prototype.pageview = function(r) {
      return g(this, void 0, void 0, function() {
        return m(this, function(n) {
          switch (n.label) {
            case 0:
              return console.warn(Y), [4, this.page({ path: r })];
            case 1:
              return n.sent(), [2, this];
          }
        });
      });
    }, Object.defineProperty(t.prototype, "plugins", {
      get: function() {
        var r;
        return console.warn(Y), (r = this._plugins) !== null && r !== void 0 ? r : {};
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "Integrations", {
      get: function() {
        console.warn(Y);
        var r = this.queue.plugins.filter(function(n) {
          return n.type === "destination";
        }).reduce(function(n, i) {
          var o = "".concat(i.name.toLowerCase().replace(".", "").split(" ").join("-"), "Integration"), a = window[o];
          if (!a)
            return n;
          var u = a.Integration;
          return u ? (n[i.name] = u, n) : (n[i.name] = a, n);
        }, {});
        return r;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.push = function(r) {
      var n = this, i = r.shift();
      i && !n[i] || n[i].apply(this, r);
    }, t;
  }(dt)
), Wt = (
  /** @class */
  function(e) {
    N(t, e);
    function t() {
      var r = e.call(this, { writeKey: "" }, { disableClientPersistence: !0 }) || this;
      return r.initialized = !0, r;
    }
    return t;
  }(Pr)
);
function Ar() {
  return typeof process > "u" || !process.env ? {} : process.env;
}
var Bi = /(https:\/\/.*)\/analytics\.js\/v1\/(?:.*?)\/(?:platform|analytics.*)?/, Ki = function() {
  var e, t = Array.prototype.slice.call(document.querySelectorAll("script"));
  return t.forEach(function(r) {
    var n, i = (n = r.getAttribute("src")) !== null && n !== void 0 ? n : "", o = Bi.exec(i);
    o && o[1] && (e = o[1]);
  }), e;
}, De, Gi = function() {
  var e, t = De ?? ((e = pr()) === null || e === void 0 ? void 0 : e._cdn);
  return t;
}, Ji = function(e) {
  var t = pr();
  t && (t._cdn = e), De = e;
}, Tt = function() {
  var e = Gi();
  if (e)
    return e;
  var t = Ki();
  return t || "https://cdn.segment.com";
}, To = function() {
  var e = Tt();
  return "".concat(e, "/next-integrations");
};
function Wi(e, t) {
  var r, n = Object.entries((r = t.integrations) !== null && r !== void 0 ? r : {}).reduce(function(i, o) {
    var a, u, s = o[0], c = o[1];
    return typeof c == "object" ? d(d({}, i), (a = {}, a[s] = c, a)) : d(d({}, i), (u = {}, u[s] = {}, u));
  }, {});
  return Object.entries(e.integrations).reduce(function(i, o) {
    var a, u = o[0], s = o[1];
    return d(d({}, i), (a = {}, a[u] = d(d({}, s), n[u]), a));
  }, {});
}
function Qi(e) {
  try {
    return decodeURIComponent(e.replace(/\+/g, " "));
  } catch {
    return e;
  }
}
function Vi(e) {
  return g(this, void 0, void 0, function() {
    var t;
    return m(this, function(r) {
      return t = navigator.userAgentData, t ? e ? [2, t.getHighEntropyValues(e).catch(function() {
        return t.toJSON();
      })] : [2, t.toJSON()] : [2, void 0];
    });
  });
}
var we;
function Hi() {
  if (we)
    return we;
  var e = sr(window.location.href);
  return we = {
    expires: 31536e6,
    secure: !1,
    path: "/"
  }, e && (we.domain = e), we;
}
function Yi(e) {
  var t = {
    btid: "dataxu",
    urid: "millennial-media"
  };
  e.startsWith("?") && (e = e.substring(1)), e = e.replace(/\?/g, "&");
  for (var r = e.split("&"), n = 0, i = r; n < i.length; n++) {
    var o = i[n], a = o.split("="), u = a[0], s = a[1];
    if (t[u])
      return {
        id: s,
        type: t[u]
      };
  }
}
function Xi(e) {
  return e.startsWith("?") && (e = e.substring(1)), e = e.replace(/\?/g, "&"), e.split("&").reduce(function(t, r) {
    var n = r.split("="), i = n[0], o = n[1], a = o === void 0 ? "" : o;
    if (i.includes("utm_") && i.length > 4) {
      var u = i.slice(4);
      u === "campaign" && (u = "name"), t[u] = Qi(a);
    }
    return t;
  }, {});
}
function Zi() {
  var e = W.get("_ga");
  if (e && e.startsWith("amp"))
    return e;
}
function eo(e, t, r) {
  var n, i = new re(r ? [] : [new cr(Hi())]), o = i.get("s:context.referrer"), a = (n = Yi(e)) !== null && n !== void 0 ? n : o;
  a && (t && (t.referrer = d(d({}, t.referrer), a)), i.set("s:context.referrer", a));
}
var to = function(e) {
  try {
    var t = new URLSearchParams();
    return Object.entries(e).forEach(function(r) {
      var n = r[0], i = r[1];
      Array.isArray(i) ? i.forEach(function(o) {
        return t.append(n, o);
      }) : t.append(n, i);
    }), t.toString();
  } catch {
    return "";
  }
}, ro = (
  /** @class */
  /* @__PURE__ */ function() {
    function e() {
      var t = this;
      this.name = "Page Enrichment", this.type = "before", this.version = "0.1.0", this.isLoaded = function() {
        return !0;
      }, this.load = function(r, n) {
        return g(t, void 0, void 0, function() {
          var i;
          return m(this, function(o) {
            switch (o.label) {
              case 0:
                this.instance = n, o.label = 1;
              case 1:
                return o.trys.push([1, 3, , 4]), i = this, [4, Vi(this.instance.options.highEntropyValuesClientHints)];
              case 2:
                return i.userAgentData = o.sent(), [3, 4];
              case 3:
                return o.sent(), [3, 4];
              case 4:
                return [2, Promise.resolve()];
            }
          });
        });
      }, this.enrich = function(r) {
        var n, i, o = r.event.context, a = o.page.search || "", u = typeof a == "object" ? to(a) : a;
        o.userAgent = navigator.userAgent, o.userAgentData = t.userAgentData;
        var s = navigator.userLanguage || navigator.language;
        typeof o.locale > "u" && typeof s < "u" && (o.locale = s), (n = o.library) !== null && n !== void 0 || (o.library = {
          name: "analytics.js",
          version: "".concat("npm:next", "-").concat(Le)
        }), u && !o.campaign && (o.campaign = Xi(u));
        var c = Zi();
        c && (o.amp = { id: c }), eo(u, o, (i = t.instance.options.disableClientPersistence) !== null && i !== void 0 ? i : !1);
        try {
          o.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        } catch {
        }
        return r;
      }, this.track = this.enrich, this.identify = this.enrich, this.page = this.enrich, this.group = this.enrich, this.alias = this.enrich, this.screen = this.enrich;
    }
    return e;
  }()
), no = new ro();
function xr(e) {
  var t = Array.prototype.slice.call(window.document.querySelectorAll("script"));
  return t.find(function(r) {
    return r.src === e;
  });
}
function Ye(e, t) {
  var r = xr(e);
  if (r !== void 0) {
    var n = r == null ? void 0 : r.getAttribute("status");
    if (n === "loaded")
      return Promise.resolve(r);
    if (n === "loading")
      return new Promise(function(i, o) {
        r.addEventListener("load", function() {
          return i(r);
        }), r.addEventListener("error", function(a) {
          return o(a);
        });
      });
  }
  return new Promise(function(i, o) {
    var a, u = window.document.createElement("script");
    u.type = "text/javascript", u.src = e, u.async = !0, u.setAttribute("status", "loading");
    for (var s = 0, c = Object.entries({}); s < c.length; s++) {
      var l = c[s], f = l[0], h = l[1];
      u.setAttribute(f, h);
    }
    u.onload = function() {
      u.onerror = u.onload = null, u.setAttribute("status", "loaded"), i(u);
    }, u.onerror = function() {
      u.onerror = u.onload = null, u.setAttribute("status", "error"), o(new Error("Failed to load ".concat(e)));
    };
    var v = window.document.querySelector("script");
    v ? (a = v.parentElement) === null || a === void 0 || a.insertBefore(u, v) : window.document.head.appendChild(u);
  });
}
function No(e) {
  var t = xr(e);
  return t !== void 0 && t.remove(), Promise.resolve();
}
function Mr(e, t, r) {
  return g(this, void 0, void 0, function() {
    function n(c, l) {
      return g(this, void 0, void 0, function() {
        var f, h, v;
        return m(this, function(p) {
          switch (p.label) {
            case 0:
              return f = !1, h = null, [4, l({
                payload: je(c, {
                  clone: !0,
                  traverse: !1
                }),
                integration: e,
                next: function(y) {
                  f = !0, y === null && (h = null), y && (h = y.obj);
                }
              })];
            case 1:
              return p.sent(), !f && h !== null && (h = h, h.integrations = d(d({}, c.integrations), (v = {}, v[e] = !1, v))), [2, h];
          }
        });
      });
    }
    var i, o, a, u, s;
    return m(this, function(c) {
      switch (c.label) {
        case 0:
          i = je(t, {
            clone: !0,
            traverse: !1
          }).rawEvent(), o = 0, a = r, c.label = 1;
        case 1:
          return o < a.length ? (u = a[o], [4, n(i, u)]) : [3, 4];
        case 2:
          if (s = c.sent(), s === null)
            return [2, null];
          i = s, c.label = 3;
        case 3:
          return o++, [3, 1];
        case 4:
          return [2, i];
      }
    });
  });
}
function io(e, t) {
  function r(n) {
    return g(this, void 0, void 0, function() {
      var i;
      return m(this, function(o) {
        switch (o.label) {
          case 0:
            return i = !1, [4, e({
              payload: je(n.event, {
                clone: !0,
                traverse: !1
              }),
              integrations: t ?? {},
              next: function(a) {
                i = !0, a && (n.event = a.obj);
              }
            })];
          case 1:
            if (o.sent(), !i)
              throw new he({
                retry: !1,
                type: "middleware_cancellation",
                reason: "Middleware `next` function skipped"
              });
            return [2, n];
        }
      });
    });
  }
  return {
    name: "Source Middleware ".concat(e.name),
    type: "before",
    version: "0.1.0",
    isLoaded: function() {
      return !0;
    },
    load: function(n) {
      return Promise.resolve(n);
    },
    track: r,
    page: r,
    identify: r,
    alias: r,
    group: r
  };
}
const oo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  applyDestinationMiddleware: Mr,
  sourceMiddlewarePlugin: io
}, Symbol.toStringTag, { value: "Module" }));
function Ce(e, t) {
  var r = t.methodName, n = t.integrationName, i = t.type, o = t.didError, a = o === void 0 ? !1 : o;
  e.stats.increment("analytics_js.integration.invoke".concat(a ? ".error" : ""), 1, [
    "method:".concat(r),
    "integration_name:".concat(n),
    "type:".concat(i)
  ]);
}
var ao = (
  /** @class */
  function() {
    function e(t, r) {
      this.version = "1.0.0", this.alternativeNames = [], this.loadPromise = Yt(), this.middleware = [], this.alias = this._createMethod("alias"), this.group = this._createMethod("group"), this.identify = this._createMethod("identify"), this.page = this._createMethod("page"), this.screen = this._createMethod("screen"), this.track = this._createMethod("track"), this.action = r, this.name = t, this.type = r.type, this.alternativeNames.push(r.name);
    }
    return e.prototype.addMiddleware = function() {
      for (var t, r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      this.type === "destination" && (t = this.middleware).push.apply(t, r);
    }, e.prototype.transform = function(t) {
      return g(this, void 0, void 0, function() {
        var r;
        return m(this, function(n) {
          switch (n.label) {
            case 0:
              return [4, Mr(this.name, t.event, this.middleware)];
            case 1:
              return r = n.sent(), r === null && t.cancel(new he({
                retry: !1,
                reason: "dropped by destination middleware"
              })), [2, new Q(r)];
          }
        });
      });
    }, e.prototype._createMethod = function(t) {
      var r = this;
      return function(n) {
        return g(r, void 0, void 0, function() {
          var i, o;
          return m(this, function(a) {
            switch (a.label) {
              case 0:
                return this.action[t] ? (i = n, this.type !== "destination" ? [3, 2] : [4, this.transform(n)]) : [2, n];
              case 1:
                i = a.sent(), a.label = 2;
              case 2:
                return a.trys.push([2, 5, , 6]), [4, this.ready()];
              case 3:
                if (!a.sent())
                  throw new Error("Something prevented the destination from getting ready");
                return Ce(n, {
                  integrationName: this.action.name,
                  methodName: t,
                  type: "action"
                }), [4, this.action[t](i)];
              case 4:
                return a.sent(), [3, 6];
              case 5:
                throw o = a.sent(), Ce(n, {
                  integrationName: this.action.name,
                  methodName: t,
                  type: "action",
                  didError: !0
                }), o;
              case 6:
                return [2, n];
            }
          });
        });
      };
    }, e.prototype.isLoaded = function() {
      return this.action.isLoaded();
    }, e.prototype.ready = function() {
      return g(this, void 0, void 0, function() {
        return m(this, function(t) {
          switch (t.label) {
            case 0:
              return t.trys.push([0, 2, , 3]), [4, this.loadPromise.promise];
            case 1:
              return t.sent(), [2, !0];
            case 2:
              return t.sent(), [2, !1];
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.load = function(t, r) {
      return g(this, void 0, void 0, function() {
        var n, i, o, a;
        return m(this, function(u) {
          switch (u.label) {
            case 0:
              if (this.loadPromise.isSettled())
                return [2, this.loadPromise.promise];
              u.label = 1;
            case 1:
              return u.trys.push([1, 3, , 4]), Ce(t, {
                integrationName: this.action.name,
                methodName: "load",
                type: "action"
              }), n = this.action.load(t, r), o = (i = this.loadPromise).resolve, [4, n];
            case 2:
              return o.apply(i, [u.sent()]), [2, n];
            case 3:
              throw a = u.sent(), Ce(t, {
                integrationName: this.action.name,
                methodName: "load",
                type: "action",
                didError: !0
              }), this.loadPromise.reject(a), a;
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.unload = function(t, r) {
      var n, i;
      return (i = (n = this.action).unload) === null || i === void 0 ? void 0 : i.call(n, t, r);
    }, e;
  }()
);
function uo(e) {
  if (!Array.isArray(e))
    throw new Error("Not a valid list of plugins");
  var t = ["load", "isLoaded", "name", "version", "type"];
  return e.forEach(function(r) {
    t.forEach(function(n) {
      var i;
      if (r[n] === void 0)
        throw new Error("Plugin: ".concat((i = r.name) !== null && i !== void 0 ? i : "unknown", " missing required function ").concat(n));
    });
  }), !0;
}
function so(e, t) {
  var r = e[t.creationName], n = e[t.name];
  return e.All === !1 && !r && !n || r === !1 || n === !1;
}
function co(e, t) {
  return g(this, void 0, void 0, function() {
    var r, n, i, o, a, u;
    return m(this, function(s) {
      switch (s.label) {
        case 0:
          if (s.trys.push([0, 9, , 10]), r = new RegExp("https://cdn.segment.(com|build)"), n = Tt(), !t) return [3, 6];
          i = e.url.split("/"), o = i[i.length - 2], a = e.url.replace(o, btoa(o).replace(/=/g, "")), s.label = 1;
        case 1:
          return s.trys.push([1, 3, , 5]), [4, Ye(a.replace(r, n))];
        case 2:
          return s.sent(), [3, 5];
        case 3:
          return s.sent(), [4, Ye(e.url.replace(r, n))];
        case 4:
          return s.sent(), [3, 5];
        case 5:
          return [3, 8];
        case 6:
          return [4, Ye(e.url.replace(r, n))];
        case 7:
          s.sent(), s.label = 8;
        case 8:
          return typeof window[e.libraryName] == "function" ? [2, window[e.libraryName]] : [3, 10];
        case 9:
          throw u = s.sent(), console.error("Failed to create PluginFactory", e), u;
        case 10:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}
function lo(e, t, r, n, i, o) {
  var a, u, s;
  return g(this, void 0, void 0, function() {
    var c, l, f, h = this;
    return m(this, function(v) {
      switch (v.label) {
        case 0:
          return c = [], l = (u = (a = e.middlewareSettings) === null || a === void 0 ? void 0 : a.routingRules) !== null && u !== void 0 ? u : [], f = ((s = e.remotePlugins) !== null && s !== void 0 ? s : []).map(function(p) {
            return g(h, void 0, void 0, function() {
              var y, S, w, I, b, M;
              return m(this, function(O) {
                switch (O.label) {
                  case 0:
                    if (so(t, p))
                      return [
                        2
                        /*return*/
                      ];
                    O.label = 1;
                  case 1:
                    return O.trys.push([1, 6, , 7]), S = o == null ? void 0 : o.find(function(x) {
                      var R = x.pluginName;
                      return R === p.name;
                    }), S ? [3, 3] : [4, co(p, n == null ? void 0 : n.obfuscate)];
                  case 2:
                    S = O.sent(), O.label = 3;
                  case 3:
                    return y = S, y ? [4, y(d(d({}, p.settings), r[p.name]))] : [3, 5];
                  case 4:
                    w = O.sent(), I = Array.isArray(w) ? w : [w], uo(I), b = l.filter(function(x) {
                      return x.destinationName === p.creationName;
                    }), I.forEach(function(x) {
                      var R = new ao(p.creationName, x);
                      b.length && i && R.addMiddleware(i), c.push(R);
                    }), O.label = 5;
                  case 5:
                    return [3, 7];
                  case 6:
                    return M = O.sent(), console.warn("Failed to load Remote Plugin", M), [3, 7];
                  case 7:
                    return [
                      2
                      /*return*/
                    ];
                }
              });
            });
          }), [4, Promise.all(f)];
        case 1:
          return v.sent(), [2, c.filter(Boolean)];
      }
    });
  });
}
var Xe, Qt, fo = yt(), Vt = (Xe = (Qt = fo).__SEGMENT_INSPECTOR__) !== null && Xe !== void 0 ? Xe : Qt.__SEGMENT_INSPECTOR__ = {}, po = function(e) {
  var t;
  return (t = Vt.attach) === null || t === void 0 ? void 0 : t.call(Vt, e);
};
function vo(e, t) {
  return Ne("".concat(t, "/v1/projects/").concat(e, "/settings")).then(function(r) {
    return r.ok ? r.json() : r.text().then(function(n) {
      throw new Error(n);
    });
  }).catch(function(r) {
    throw console.error(r.message), r;
  });
}
function ho(e) {
  return Ar().NODE_ENV !== "test" && // just one integration means segmentio
  Object.keys(e.integrations).length > 1;
}
function yo(e) {
  var t, r, n;
  return Ar().NODE_ENV !== "test" && ((n = (r = (t = e.middlewareSettings) === null || t === void 0 ? void 0 : t.routingRules) === null || r === void 0 ? void 0 : r.length) !== null && n !== void 0 ? n : 0) > 0;
}
function go(e, t) {
  qn(e, t), Rn(e, t);
}
function mo(e, t) {
  return g(this, void 0, void 0, function() {
    return m(this, function(r) {
      switch (r.label) {
        case 0:
          return [4, Nn(e, t)];
        case 1:
          return r.sent(), $n(e, t), [
            2
            /*return*/
          ];
      }
    });
  });
}
function bo(e, t, r, n, i, o, a) {
  var u, s, c;
  return i === void 0 && (i = []), g(this, void 0, void 0, function() {
    var l, f, h, v, p, y, S, w, I, b, M, O, x, R, X, Pe = this;
    return m(this, function(C) {
      switch (C.label) {
        case 0:
          return go(r, a), l = i == null ? void 0 : i.filter(function(E) {
            return typeof E == "object";
          }), f = i == null ? void 0 : i.filter(function(E) {
            return typeof E == "function" && typeof E.pluginName == "string";
          }), yo(t) ? [4, import(
            /* webpackChunkName: "tsub-middleware" */
            "./index-CQu25aox.js"
          ).then(function(E) {
            return E.tsubMiddleware(t.middlewareSettings.routingRules);
          })] : [3, 2];
        case 1:
          return v = C.sent(), [3, 3];
        case 2:
          v = void 0, C.label = 3;
        case 3:
          return h = v, ho(t) || o.length > 0 ? [4, import(
            /* webpackChunkName: "ajs-destination" */
            "./index-vMf7hoI-.js"
          ).then(function(E) {
            return E.ajsDestinations(e, t, r.integrations, n, h, o);
          })] : [3, 5];
        case 4:
          return y = C.sent(), [3, 6];
        case 5:
          y = [], C.label = 6;
        case 6:
          return p = y, t.legacyVideoPluginsEnabled ? [4, import(
            /* webpackChunkName: "legacyVideos" */
            "./index-DgBVVp1z.js"
          ).then(function(E) {
            return E.loadLegacyVideoPlugins(r);
          })] : [3, 8];
        case 7:
          C.sent(), C.label = 8;
        case 8:
          return !((u = n.plan) === null || u === void 0) && u.track ? [4, import(
            /* webpackChunkName: "schemaFilter" */
            "./index-DdmjJxjV.js"
          ).then(function(E) {
            var Z;
            return E.schemaFilter((Z = n.plan) === null || Z === void 0 ? void 0 : Z.track, t);
          })] : [3, 10];
        case 9:
          return w = C.sent(), [3, 11];
        case 10:
          w = void 0, C.label = 11;
        case 11:
          return S = w, I = Wi(t, n), [4, lo(t, r.integrations, I, n, h, f).catch(function() {
            return [];
          })];
        case 12:
          return b = C.sent(), M = D(D([no], p, !0), b, !0), S && M.push(S), O = ((s = n.integrations) === null || s === void 0 ? void 0 : s.All) === !1 && !n.integrations["Segment.io"] || n.integrations && n.integrations["Segment.io"] === !1, O ? [3, 14] : (R = (x = M).push, [4, $i(r, I["Segment.io"], t.integrations)]);
        case 13:
          R.apply(x, [C.sent()]), C.label = 14;
        case 14:
          return [4, r.register.apply(r, D(D([], M, !1), l, !1))];
        case 15:
          return X = C.sent(), [4, Ln(r, a)];
        case 16:
          return C.sent(), Object.entries((c = t.enabledMiddleware) !== null && c !== void 0 ? c : {}).some(function(E) {
            var Z = E[1];
            return Z;
          }) ? [4, import(
            /* webpackChunkName: "remoteMiddleware" */
            "./index-CAVQabfG.js"
          ).then(function(E) {
            var Z = E.remoteMiddlewares;
            return g(Pe, void 0, void 0, function() {
              var Nt, Lt;
              return m(this, function(Rt) {
                switch (Rt.label) {
                  case 0:
                    return [4, Z(X, t, n.obfuscate)];
                  case 1:
                    return Nt = Rt.sent(), Lt = Nt.map(function(Dr) {
                      return r.addSourceMiddleware(Dr);
                    }), [2, Promise.all(Lt)];
                }
              });
            });
          })] : [3, 18];
        case 17:
          C.sent(), C.label = 18;
        case 18:
          return [2, X];
      }
    });
  });
}
function wo(e, t, r) {
  var n, i, o, a, u, s, c, l, f, h, v;
  return t === void 0 && (t = {}), g(this, void 0, void 0, function() {
    var p, y, S, w, I, b, M, O, x, R, X, Pe, C;
    return m(this, function(E) {
      switch (E.label) {
        case 0:
          return t.disable === !0 ? [2, [new Wt(), Q.system()]] : (t.globalAnalyticsKey && Fn(t.globalAnalyticsKey), e.cdnURL && Ji(e.cdnURL), t.initialPageview && r.add(new ot("page", [])), p = (n = e.cdnURL) !== null && n !== void 0 ? n : Tt(), (i = e.cdnSettings) !== null && i !== void 0 ? (S = i, [3, 3]) : [3, 1]);
        case 1:
          return [4, vo(e.writeKey, p)];
        case 2:
          S = E.sent(), E.label = 3;
        case 3:
          return y = S, t.updateCDNSettings && (y = t.updateCDNSettings(y)), typeof t.disable != "function" ? [3, 5] : [4, t.disable(y)];
        case 4:
          if (w = E.sent(), w)
            return [2, [new Wt(), Q.system()]];
          E.label = 5;
        case 5:
          return I = (a = (o = y.integrations["Segment.io"]) === null || o === void 0 ? void 0 : o.retryQueue) !== null && a !== void 0 ? a : !0, t = d({ retryQueue: I }, t), b = new Pr(d(d({}, e), { cdnSettings: y, cdnURL: p }), t), po(b), M = (u = e.plugins) !== null && u !== void 0 ? u : [], O = (s = e.classicIntegrations) !== null && s !== void 0 ? s : [], x = (c = t.integrations) === null || c === void 0 ? void 0 : c["Segment.io"], tr.initRemoteMetrics(d(d({}, y.metrics), { host: (l = x == null ? void 0 : x.apiHost) !== null && l !== void 0 ? l : (f = y.metrics) === null || f === void 0 ? void 0 : f.host, protocol: x == null ? void 0 : x.protocol })), [4, bo(e.writeKey, y, b, t, M, O, r)];
        case 6:
          return R = E.sent(), X = (h = window.location.search) !== null && h !== void 0 ? h : "", Pe = (v = window.location.hash) !== null && v !== void 0 ? v : "", C = X.length ? X : Pe.replace(/(?=#).*(?=\?)/, ""), C.includes("ajs_") ? [4, b.queryString(C).catch(console.error)] : [3, 8];
        case 7:
          E.sent(), E.label = 8;
        case 8:
          return b.initialized = !0, b.emit("initialize", e, t), [4, mo(b, r)];
        case 9:
          return E.sent(), [2, [b, R]];
      }
    });
  });
}
var _o = (
  /** @class */
  function(e) {
    N(t, e);
    function t() {
      var r = this, n = Yt(), i = n.promise, o = n.resolve;
      return r = e.call(this, function(a) {
        return i.then(function(u) {
          var s = u[0], c = u[1];
          return wo(s, c, a);
        });
      }) || this, r._resolveLoadStart = function(a, u) {
        return o([a, u]);
      }, r;
    }
    return t.prototype.load = function(r, n) {
      return n === void 0 && (n = {}), this._resolveLoadStart(r, n), this;
    }, t.load = function(r, n) {
      return n === void 0 && (n = {}), new t().load(r, n);
    }, t.standalone = function(r, n) {
      return t.load({ writeKey: r }, n).then(function(i) {
        return i[0];
      });
    }, t;
  }(zn)
);
const Cr = "flare_analytics_data";
function Te() {
  return typeof window < "u";
}
function So(e, t) {
  if (Te())
    try {
      const n = { ...kr(e), ...t }, i = JSON.stringify(n);
      window.localStorage.setItem(e, i);
    } catch (r) {
      console.error("Error storing data in localStorage:", r);
    }
}
function kr(e) {
  if (!Te()) return null;
  try {
    const t = localStorage.getItem(e);
    return t === null ? null : JSON.parse(t);
  } catch (t) {
    console.error("Error retrieving data from localStorage:", t);
  }
  return null;
}
const Io = {
  name: "Persistent data",
  type: "enrichment",
  version: "1.0.0",
  isLoaded: () => !0,
  load: () => Promise.resolve(),
  track: (e) => {
    const t = e.event.properties, r = kr(Cr);
    return e.updateEvent("properties", {
      ...t,
      ...r
    }), e;
  }
};
let K;
function Eo({ debug: e, disable: t, writeKey: r }) {
  K = _o.load({ writeKey: r }, { disable: t }), e && Te() && K.debug(e), Te() && K.register(Io);
}
function Oo(e, t) {
  K.track(e, t);
}
function Po(e, t, r) {
  K.page(r, e, t);
}
function Ao(e, t) {
  K.identify(e, t);
}
function xo(e, t) {
  K.alias(e, t);
}
function Mo(e) {
  return K.ready(e);
}
async function Co() {
  return (await K.user()).anonymousId();
}
async function ko() {
  return (await K.user()).id();
}
function Do(e) {
  So(Cr, e);
}
const Lo = {
  alias: xo,
  getAnonymousId: Co,
  getUserId: ko,
  identify: Ao,
  init: Eo,
  page: Po,
  ready: Mo,
  setPersistentData: Do,
  track: Oo
};
export {
  he as C,
  pt as P,
  g as _,
  m as a,
  D as b,
  d as c,
  Mr as d,
  H as e,
  Fo as f,
  To as g,
  q as h,
  Se as i,
  Yt as j,
  gt as k,
  Ye as l,
  Wi as m,
  _e as n,
  cn as o,
  Ni as p,
  Q as q,
  Ce as r,
  Gr as s,
  Qi as t,
  No as u,
  jo as v,
  Lo as w
};
